// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { addClientContacts, addClientName, attachTriageEntry, cancelClientImport, cancelQrConnect, changeChannelToken, checkConciergeModel, closeTriageEntry, commitClientImport, connectByToken, createBooking, createContent, createScenario, createScenarioFromTemplate, deleteApartmentVariableKey, deleteChannel, deleteContent, deleteScenario, disableChannel, dismissAiDraft, dryRunScenario, enableChannel, fillApartmentVariable, getApartment, getApartmentVariableMatrix, getBadges, getBooking, getBookingFormReference, getBookingGuestScreen, getBrand, getChannelCascade, getChannelCatalog, getChannelLimits, getChessPeriod, getClient, getClientCatalog, getClientImport, getClientsSummary, getConcierge, getContent, getContentAuthoringCatalog, getConversation, getConversationTimeline, getDashboard, getFlowSlice, getMe, getPaymentSettings, getPolicy, getQrConnect, getScenario, getScenarioBotMap, getScenarioCatalog, getSourceSyncScope, getTaskQueue, importApartmentVariables, listApartments, listAuditEvents, listBookings, listBotLinks, listChannelEvents, listChannels, listChessObjects, listClientImportRows, listClients, listCompanies, listContent, listContentRoles, listContentRoleStatus, listConversations, listGatedRoles, listNotifications, listPlatformServices, listScenarios, listScenarioTemplates, listSecretReveals, listSources, listTriage, logout, markNotificationsRead, type Options, previewContent, publishContent, publishScenario, recordBookingPayment, refreshQrConnect, relinkChannel, removeClientContact, renameScenario, resendGuestLink, runBookingAction, runBookingIntervention, runTaskAction, saveApartmentSecret, saveBrand, saveChannelCascade, saveConcierge, saveContent, saveDepositSettings, savePolicy, saveScenarioDraft, search, sendAiDraft, sendMessage, setApartmentSecretLabel, setApartmentVariables, setClientDisplayName, setConversationMode, startQrConnect, submitQrPassword, switchCompany, unlinkClient, updateBooking, updateChannel, updateClientContactLabel, uploadClientImport, validateContent, validateScenario, voidBookingPayment } from '../sdk.gen';
import type { AddClientContactsData, AddClientContactsError, AddClientContactsResponse, AddClientNameData, AddClientNameError, AddClientNameResponse, AttachTriageEntryData, AttachTriageEntryError, AttachTriageEntryResponse, CancelClientImportData, CancelClientImportError, CancelClientImportResponse, CancelQrConnectData, CancelQrConnectError, CancelQrConnectResponse, ChangeChannelTokenData, ChangeChannelTokenError, ChangeChannelTokenResponse, CheckConciergeModelData, CheckConciergeModelError, CheckConciergeModelResponse, CloseTriageEntryData, CloseTriageEntryError, CloseTriageEntryResponse, CommitClientImportData, CommitClientImportError, CommitClientImportResponse, ConnectByTokenData, ConnectByTokenError, ConnectByTokenResponse, CreateBookingData, CreateBookingError, CreateBookingResponse, CreateContentData, CreateContentError, CreateContentResponse, CreateScenarioData, CreateScenarioError, CreateScenarioFromTemplateData, CreateScenarioFromTemplateError, CreateScenarioFromTemplateResponse, CreateScenarioResponse, Cursor, DeleteApartmentVariableKeyData, DeleteApartmentVariableKeyError, DeleteApartmentVariableKeyResponse, DeleteChannelData, DeleteChannelError, DeleteChannelResponse, DeleteContentData, DeleteContentError, DeleteContentResponse, DeleteScenarioData, DeleteScenarioError, DeleteScenarioResponse, DisableChannelData, DisableChannelError, DisableChannelResponse, DismissAiDraftData, DismissAiDraftError, DismissAiDraftResponse, DryRunScenarioData, DryRunScenarioError, DryRunScenarioResponse, EnableChannelData, EnableChannelError, EnableChannelResponse, FillApartmentVariableData, FillApartmentVariableError, FillApartmentVariableResponse, GetApartmentData, GetApartmentError, GetApartmentResponse, GetApartmentVariableMatrixData, GetApartmentVariableMatrixError, GetApartmentVariableMatrixResponse, GetBadgesData, GetBadgesError, GetBadgesResponse, GetBookingData, GetBookingError, GetBookingFormReferenceData, GetBookingFormReferenceError, GetBookingFormReferenceResponse, GetBookingGuestScreenData, GetBookingGuestScreenError, GetBookingGuestScreenResponse, GetBookingResponse, GetBrandData, GetBrandError, GetBrandResponse, GetChannelCascadeData, GetChannelCascadeError, GetChannelCascadeResponse, GetChannelCatalogData, GetChannelCatalogError, GetChannelCatalogResponse, GetChannelLimitsData, GetChannelLimitsError, GetChannelLimitsResponse, GetChessPeriodData, GetChessPeriodError, GetChessPeriodResponse, GetClientCatalogData, GetClientCatalogError, GetClientCatalogResponse, GetClientData, GetClientError, GetClientImportData, GetClientImportError, GetClientImportResponse, GetClientResponse, GetClientsSummaryData, GetClientsSummaryError, GetClientsSummaryResponse, GetConciergeData, GetConciergeError, GetConciergeResponse, GetContentAuthoringCatalogData, GetContentAuthoringCatalogError, GetContentAuthoringCatalogResponse, GetContentData, GetContentError, GetContentResponse, GetConversationData, GetConversationError, GetConversationResponse, GetConversationTimelineData, GetConversationTimelineError, GetConversationTimelineResponse, GetDashboardData, GetDashboardError, GetDashboardResponse, GetFlowSliceData, GetFlowSliceError, GetFlowSliceResponse, GetMeData, GetMeError, GetMeResponse, GetPaymentSettingsData, GetPaymentSettingsError, GetPaymentSettingsResponse, GetPolicyData, GetPolicyError, GetPolicyResponse, GetQrConnectData, GetQrConnectError, GetQrConnectResponse, GetScenarioBotMapData, GetScenarioBotMapError, GetScenarioBotMapResponse, GetScenarioCatalogData, GetScenarioCatalogError, GetScenarioCatalogResponse, GetScenarioData, GetScenarioError, GetScenarioResponse, GetSourceSyncScopeData, GetSourceSyncScopeError, GetSourceSyncScopeResponse, GetTaskQueueData, GetTaskQueueError, GetTaskQueueResponse, ImportApartmentVariablesData, ImportApartmentVariablesError, ImportApartmentVariablesResponse, ListApartmentsData, ListApartmentsError, ListApartmentsResponse, ListAuditEventsData, ListAuditEventsError, ListAuditEventsResponse, ListBookingsData, ListBookingsError, ListBookingsResponse, ListBotLinksData, ListBotLinksError, ListBotLinksResponse, ListChannelEventsData, ListChannelEventsError, ListChannelEventsResponse, ListChannelsData, ListChannelsError, ListChannelsResponse, ListChessObjectsData, ListChessObjectsError, ListChessObjectsResponse, ListClientImportRowsData, ListClientImportRowsError, ListClientImportRowsResponse, ListClientsData, ListClientsError, ListClientsResponse, ListCompaniesData, ListCompaniesError, ListCompaniesResponse, ListContentData, ListContentError, ListContentResponse, ListContentRolesData, ListContentRolesError, ListContentRolesResponse, ListContentRoleStatusData, ListContentRoleStatusError, ListContentRoleStatusResponse, ListConversationsData, ListConversationsError, ListConversationsResponse, ListGatedRolesData, ListGatedRolesError, ListGatedRolesResponse, ListNotificationsData, ListNotificationsError, ListNotificationsResponse, ListPlatformServicesData, ListPlatformServicesError, ListPlatformServicesResponse, ListScenariosData, ListScenariosError, ListScenariosResponse, ListScenarioTemplatesData, ListScenarioTemplatesError, ListScenarioTemplatesResponse, ListSecretRevealsData, ListSecretRevealsError, ListSecretRevealsResponse, ListSourcesData, ListSourcesError, ListSourcesResponse, ListTriageData, ListTriageError, ListTriageResponse, LogoutData, LogoutResponse, MarkNotificationsReadData, MarkNotificationsReadError, MarkNotificationsReadResponse, PreviewContentData, PreviewContentError, PreviewContentResponse, PublishContentData, PublishContentError, PublishContentResponse, PublishScenarioData, PublishScenarioError, PublishScenarioResponse, RecordBookingPaymentData, RecordBookingPaymentError, RecordBookingPaymentResponse, RefreshQrConnectData, RefreshQrConnectError, RefreshQrConnectResponse, RelinkChannelData, RelinkChannelError, RelinkChannelResponse, RemoveClientContactData, RemoveClientContactError, RemoveClientContactResponse, RenameScenarioData, RenameScenarioError, RenameScenarioResponse, ResendGuestLinkData, ResendGuestLinkError, ResendGuestLinkResponse, RunBookingActionData, RunBookingActionError, RunBookingActionResponse, RunBookingInterventionData, RunBookingInterventionError, RunBookingInterventionResponse, RunTaskActionData, RunTaskActionError, RunTaskActionResponse, SaveApartmentSecretData, SaveApartmentSecretError, SaveApartmentSecretResponse, SaveBrandData, SaveBrandError, SaveBrandResponse, SaveChannelCascadeData, SaveChannelCascadeError, SaveChannelCascadeResponse, SaveConciergeData, SaveConciergeError, SaveConciergeResponse, SaveContentData, SaveContentError, SaveContentResponse, SaveDepositSettingsData, SaveDepositSettingsError, SaveDepositSettingsResponse, SavePolicyData, SavePolicyError, SavePolicyResponse, SaveScenarioDraftData, SaveScenarioDraftError, SaveScenarioDraftResponse, SearchData, SearchError, SearchResponse, SendAiDraftData, SendAiDraftError, SendAiDraftResponse, SendMessageData, SendMessageError, SendMessageResponse, SetApartmentSecretLabelData, SetApartmentSecretLabelError, SetApartmentSecretLabelResponse, SetApartmentVariablesData, SetApartmentVariablesError, SetApartmentVariablesResponse, SetClientDisplayNameData, SetClientDisplayNameError, SetClientDisplayNameResponse, SetConversationModeData, SetConversationModeError, SetConversationModeResponse, StartQrConnectData, StartQrConnectError, StartQrConnectResponse, SubmitQrPasswordData, SubmitQrPasswordError, SubmitQrPasswordResponse, SwitchCompanyData, SwitchCompanyError, SwitchCompanyResponse, UnlinkClientData, UnlinkClientError, UnlinkClientResponse, UpdateBookingData, UpdateBookingError, UpdateBookingResponse, UpdateChannelData, UpdateChannelError, UpdateChannelResponse, UpdateClientContactLabelData, UpdateClientContactLabelError, UpdateClientContactLabelResponse, UploadClientImportData, UploadClientImportError, UploadClientImportResponse, ValidateContentData, ValidateContentError, ValidateContentResponse, ValidateScenarioData, ValidateScenarioError, ValidateScenarioResponse, VoidBookingPaymentData, VoidBookingPaymentError, VoidBookingPaymentResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey('getMe', options);

/**
 * Текущий пользователь и компания
 */
export const getMeOptions = (options?: Options<GetMeData>) => queryOptions<GetMeResponse, GetMeError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMeQueryKey(options)
});

export const listCompaniesQueryKey = (options?: Options<ListCompaniesData>) => createQueryKey('listCompanies', options);

/**
 * Компании пользователя
 *
 * ВСЕ компании пользователя, **включая текущую** (ту, что лежит в `Session.company`). Не «другие компании», а именно все.
 *
 * Это не придирка: поповер компаний показывает в шапке их общее число («4» в макете, строка 139), а ниже — карточку текущей компании отдельно и список «Другие компании» под ней. Верни gateway только остальные — и счётчик молча покажет «3». Список при этом выглядел бы правильным (фронт всё равно отфильтровывает текущую), так что ошибку заметили бы не сразу и искали бы долго.
 *
 * Порядок не важен: фронт сам отделяет текущую по `id`.
 */
export const listCompaniesOptions = (options?: Options<ListCompaniesData>) => queryOptions<ListCompaniesResponse, ListCompaniesError, ListCompaniesResponse, ReturnType<typeof listCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCompaniesQueryKey(options)
});

/**
 * Переключить активную компанию
 *
 * Сервер меняет компанию в сессии. Фронт после успеха чистит весь кеш.
 */
export const switchCompanyMutation = (options?: Partial<Options<SwitchCompanyData>>): UseMutationOptions<SwitchCompanyResponse, SwitchCompanyError, Options<SwitchCompanyData>> => {
    const mutationOptions: UseMutationOptions<SwitchCompanyResponse, SwitchCompanyError, Options<SwitchCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await switchCompany({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBadgesQueryKey = (options?: Options<GetBadgesData>) => createQueryKey('getBadges', options);

/**
 * Счётчики шапки
 *
 * Три числа для шапки: бейдж «Задачи», точка непрочитанных на «Чатах», точка на колокольчике. Шапка висит на каждом экране и опрашивается постоянно — ответ обязан быть дешёвым. Подробнее, почему это отдельная ручка, — в описании схемы Badges.
 */
export const getBadgesOptions = (options?: Options<GetBadgesData>) => queryOptions<GetBadgesResponse, GetBadgesError, GetBadgesResponse, ReturnType<typeof getBadgesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBadges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBadgesQueryKey(options)
});

export const listPlatformServicesQueryKey = (options?: Options<ListPlatformServicesData>) => createQueryKey('listPlatformServices', options);

/**
 * Сервисы платформы Prima
 *
 * Список для переключателя сервисов в шапке — с чем ещё связана компания.
 */
export const listPlatformServicesOptions = (options?: Options<ListPlatformServicesData>) => queryOptions<ListPlatformServicesResponse, ListPlatformServicesError, ListPlatformServicesResponse, ReturnType<typeof listPlatformServicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPlatformServices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPlatformServicesQueryKey(options)
});

export const listNotificationsQueryKey = (options?: Options<ListNotificationsData>) => createQueryKey('listNotifications', options);

/**
 * Лента уведомлений
 */
export const listNotificationsOptions = (options?: Options<ListNotificationsData>) => queryOptions<ListNotificationsResponse, ListNotificationsError, ListNotificationsResponse, ReturnType<typeof listNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotificationsQueryKey(options)
});

/**
 * Отметить уведомления прочитанными
 *
 * С телом `{ ids: [...] }` помечает прочитанными перечисленные в `ids` уведомления. Без тела — помечает прочитанными все уведомления: именно это должно происходить, когда пользователь открывает поповер уведомлений и видит их целиком.
 */
export const markNotificationsReadMutation = (options?: Partial<Options<MarkNotificationsReadData>>): UseMutationOptions<MarkNotificationsReadResponse, MarkNotificationsReadError, Options<MarkNotificationsReadData>> => {
    const mutationOptions: UseMutationOptions<MarkNotificationsReadResponse, MarkNotificationsReadError, Options<MarkNotificationsReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markNotificationsRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchQueryKey = (options: Options<SearchData>) => createQueryKey('search', options);

/**
 * Глобальный поиск по броням, клиентам и апартаментам
 */
export const searchOptions = (options: Options<SearchData>) => queryOptions<SearchResponse, SearchError, SearchResponse, ReturnType<typeof searchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchQueryKey(options)
});

export const getDashboardQueryKey = (options?: Options<GetDashboardData>) => createQueryKey('getDashboard', options);

/**
 * Экран Сводки
 *
 * BFF-ручка: один запрос отдаёт весь экран целиком (приветствие, KPI, гистограмма занятости, источники брони, заезды/выезды, блок внимания). Фронт не досчитывает и не досортировывает данные — сервер уже отдал их в подающемся виде.
 */
export const getDashboardOptions = (options?: Options<GetDashboardData>) => queryOptions<GetDashboardResponse, GetDashboardError, GetDashboardResponse, ReturnType<typeof getDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardQueryKey(options)
});

export const listChessObjectsQueryKey = (options?: Options<ListChessObjectsData>) => createQueryKey('listChessObjects', options);

/**
 * Ось строк шахматки — апартаменты
 *
 * До 100 объектов компании. Список не зависит от диапазона дат и не меняется при горизонтальной прокрутке шахматки, поэтому это отдельная ручка от /chess/period: пересылать те же 100 объектов в каждом чанке прокрутки было бы лишней нагрузкой.
 */
export const listChessObjectsOptions = (options?: Options<ListChessObjectsData>) => queryOptions<ListChessObjectsResponse, ListChessObjectsError, ListChessObjectsResponse, ReturnType<typeof listChessObjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChessObjects({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChessObjectsQueryKey(options)
});

export const getChessPeriodQueryKey = (options: Options<GetChessPeriodData>) => createQueryKey('getChessPeriod', options);

/**
 * Ось дней и брони шахматки за период
 *
 * Отдаёт дни диапазона (уже размеченные днём недели, флагами выходного и первого дня месяца — фронт не считает даты и не знает про локаль) и плитки броней, пересекающие диапазон. Фронт грузит период чанками при панорамировании шахматки по горизонтали; объекты (ось строк) сюда не входят — см. /chess/objects.
 */
export const getChessPeriodOptions = (options: Options<GetChessPeriodData>) => queryOptions<GetChessPeriodResponse, GetChessPeriodError, GetChessPeriodResponse, ReturnType<typeof getChessPeriodQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChessPeriod({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChessPeriodQueryKey(options)
});

export const listBookingsQueryKey = (options?: Options<ListBookingsData>) => createQueryKey('listBookings', options);

/**
 * Список броней
 */
export const listBookingsOptions = (options?: Options<ListBookingsData>) => queryOptions<ListBookingsResponse, ListBookingsError, ListBookingsResponse, ReturnType<typeof listBookingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBookings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBookingsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listBookingsInfiniteQueryKey = (options?: Options<ListBookingsData>): QueryKey<Options<ListBookingsData>> => createQueryKey('listBookings', options, true);

/**
 * Список броней
 */
export const listBookingsInfiniteOptions = (options?: Options<ListBookingsData>) => {
    const opts = infiniteQueryOptions<ListBookingsResponse, ListBookingsError, InfiniteData<ListBookingsResponse>, QueryKey<Options<ListBookingsData>>, Cursor | Pick<QueryKey<Options<ListBookingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBookingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBookings({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBookingsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Создать бронь
 */
export const createBookingMutation = (options?: Partial<Options<CreateBookingData>>): UseMutationOptions<CreateBookingResponse, CreateBookingError, Options<CreateBookingData>> => {
    const mutationOptions: UseMutationOptions<CreateBookingResponse, CreateBookingError, Options<CreateBookingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBooking({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFlowSliceQueryKey = (options?: Options<GetFlowSliceData>) => createQueryKey('getFlowSlice', options);

/**
 * Разбивка активных броней по шагам флоу оформления
 *
 * Узкая полоса-легенда над списком броней: сколько броней сейчас стоит на каждом шаге флоу (stage — это key одного из шагов BookingDetail.flow, т.е. FlowStep.key внутри flow.steps). Бронь, у которой текущего шага нет (сценарий не начат, дошёл до конца или остановлен отменой), не считается НИГДЕ: приписать её первому шагу значило бы утверждать, что она там стоит. Отдельная ручка, а не поле в BookingList, — считается по всей компании, а не по текущей странице/фильтру списка.
 */
export const getFlowSliceOptions = (options?: Options<GetFlowSliceData>) => queryOptions<GetFlowSliceResponse, GetFlowSliceError, GetFlowSliceResponse, ReturnType<typeof getFlowSliceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlowSlice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowSliceQueryKey(options)
});

export const getBookingQueryKey = (options: Options<GetBookingData>) => createQueryKey('getBooking', options);

/**
 * Карточка брони
 *
 * BFF-ручка: всё для карточки брони одним ответом — флоу оформления, платежи, клиент, требуемые действия. Фронт не собирает карточку из нескольких запросов по отдельным сущностям.
 */
export const getBookingOptions = (options: Options<GetBookingData>) => queryOptions<GetBookingResponse, GetBookingError, GetBookingResponse, ReturnType<typeof getBookingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBooking({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingQueryKey(options)
});

/**
 * Изменить бронь
 *
 * Правит то немногое, что домен у брони правит: число гостей, примечание к брони и примечание к закрытому периоду. Всё остальное меняется не здесь — квартира отдельной ручкой домена, статус через действия и «вмешаться в бронь», а даты и суммы не правятся вовсе.
 *
 * ⚠️ `If-Match` ОБЯЗАТЕЛЕН: домен принимает `expected_version >= 1` и отвергает запись, если версия разошлась. Клиент кладёт сюда `BookingDetail.version` — ту, которую прочитал перед правкой. Разошлась — 409, и на экране это не «ошибка сети», а «бронь успели поменять»: перечитать и показать свежее.
 */
export const updateBookingMutation = (options?: Partial<Options<UpdateBookingData>>): UseMutationOptions<UpdateBookingResponse, UpdateBookingError, Options<UpdateBookingData>> => {
    const mutationOptions: UseMutationOptions<UpdateBookingResponse, UpdateBookingError, Options<UpdateBookingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBooking({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Выполнить требуемое действие по брони
 *
 * Кнопка из actionsRequired брони (например «Подтвердить платёж»). Ответ — обновлённая карточка брони, actionsRequired в ней уже без выполненного пункта.
 * ⚠️ Тело ОБЯЗАТЕЛЬНО: «почему» требуется у каждого действия (3.2), и без него сервер операцию не выполнит. У действия с `needsAmount` там же приезжает сумма — её сервер выдумать не может.
 *
 * ⚠️ Ключ действия НЕ ВСЕГДА адресует шаг однозначно. При параллельных ветках бронь может стоять на ДВУХ ручных шагах с одинаковым ключом — тогда сервер отвечает `409`, и закрыть такую задачу отсюда нельзя в принципе: выбирать за менеджера, какую из двух он имел в виду, нечем. Путь для этого — очередь: `POST /tasks/{taskId}/actions/{actionKey}`, где шаг назван идентификатором задачи, а не ключом действия.
 */
export const runBookingActionMutation = (options?: Partial<Options<RunBookingActionData>>): UseMutationOptions<RunBookingActionResponse, RunBookingActionError, Options<RunBookingActionData>> => {
    const mutationOptions: UseMutationOptions<RunBookingActionResponse, RunBookingActionError, Options<RunBookingActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runBookingAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Вмешаться в ход конкретной брони
 *
 * Правка на ЖИВОЙ брони (3.2B): пропустить шаг, сменить кто подтверждает, изменить сумму, перевести на новую версию сценария, отменить. Касается ТОЛЬКО этой брони — сценарий и остальные брони не меняются.
 * ⚠️ Отказ приходит с кодом 200 и `applied: false` — это ОТВЕТ, а не ошибка (3.2B). Перевод на новую версию система вправе отклонить и объяснить причины списком; менеджер при этом ничего не сломал, и красный сбой сказал бы ему неправду. Ошибки ручки (нет причины, нет суммы, операция недоступна) — по-прежнему 4xx.
 * «Почему» обязательно у каждой правки: оно пишется в историю брони.
 */
export const runBookingInterventionMutation = (options?: Partial<Options<RunBookingInterventionData>>): UseMutationOptions<RunBookingInterventionResponse, RunBookingInterventionError, Options<RunBookingInterventionData>> => {
    const mutationOptions: UseMutationOptions<RunBookingInterventionResponse, RunBookingInterventionError, Options<RunBookingInterventionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runBookingIntervention({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Записать платёж по брони
 *
 * Ручная запись менеджера: наличные на заселении, залог, возврат, удержанный штраф.
 *
 * Ответ — ЛЕНТА ЦЕЛИКОМ со сводом, а не добавленная строка. Так решил домен, и решение верное: после записи меняется не одна строка, а весь свод — оплаченное, залог, проценты, — и собирать новую картину из старой на клиенте значило бы держать вторую реализацию их арифметики.
 *
 * ⚠️ `Idempotency-Key` обязателен по той же причине, что у создания брони: клиент не отличает «сервер не получил» от «получил, записал, а ответ потерялся». Без ключа повтор после сбоя сети записал бы ВТОРОЙ платёж живыми деньгами.
 */
export const recordBookingPaymentMutation = (options?: Partial<Options<RecordBookingPaymentData>>): UseMutationOptions<RecordBookingPaymentResponse, RecordBookingPaymentError, Options<RecordBookingPaymentData>> => {
    const mutationOptions: UseMutationOptions<RecordBookingPaymentResponse, RecordBookingPaymentError, Options<RecordBookingPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordBookingPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отменить ошибочную запись платежа
 *
 * Отмена РУЧНОЙ записи: деньги вводит человек, человек ошибается цифрой, и без отмены опечатка осталась бы неверной суммой навсегда.
 *
 * ⚠️ ЗАПИСЬ НЕ УДАЛЯЕТСЯ, А ПОМЕЧАЕТСЯ ОТМЕНЁННОЙ. «Записали и отменили» — часть финансовой истории; в свод такие строки не входят, но со страницы не исчезают.
 *
 * ⚠️ СТРОКУ ПЛОЩАДКИ ОТМЕНИТЬ НЕЛЬЗЯ — сервер ответит 422. Отказ честный: источник истины по её строкам площадка, и наша правка была бы стёрта следующим же снапшотом. Интерфейс до этого доводить не должен: кнопка отмены рисуется только у записей с `canVoid`.
 */
export const voidBookingPaymentMutation = (options?: Partial<Options<VoidBookingPaymentData>>): UseMutationOptions<VoidBookingPaymentResponse, VoidBookingPaymentError, Options<VoidBookingPaymentData>> => {
    const mutationOptions: UseMutationOptions<VoidBookingPaymentResponse, VoidBookingPaymentError, Options<VoidBookingPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voidBookingPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBookingGuestScreenQueryKey = (options: Options<GetBookingGuestScreenData>) => createQueryKey('getBookingGuestScreen', options);

/**
 * Что у гостя на экране прямо сейчас
 *
 * Живой экран гостя (3.3): чаты с ботом, чего ждёт бронь, что гостю доступно сейчас и кто отвечает. Отдельная ручка, а не поле карточки: состояние ЖИВОЕ и читается по требованию — тянуть его на каждое открытие карточки значило бы платить за то, что чаще всего не смотрят.
 * ⚠️ ТОЛЬКО ПРОСМОТР. Экран гостя — производная от сценария и контента, второго редактора бота нет (6.12). Текстов памяток тут не бывает: показ памятки оставил бы след в переписке ГОСТЯ.
 * ⚠️ `available: false` — «не смогли узнать», а не «бронь ничего не ждёт». Разница принципиальна: без неё сбой сервиса сценариев выглядит как пустая бронь.
 */
export const getBookingGuestScreenOptions = (options: Options<GetBookingGuestScreenData>) => queryOptions<GetBookingGuestScreenResponse, GetBookingGuestScreenError, GetBookingGuestScreenResponse, ReturnType<typeof getBookingGuestScreenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingGuestScreen({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingGuestScreenQueryKey(options)
});

/**
 * Переотправить гостю ссылку на бота
 *
 * Сервер выпускает свежую персональную ссылку и САМ отправляет её в чат гостя (3.5).
 *
 * ⚠️ В ОТВЕТЕ НЕТ НИ КОДА, НИ АДРЕСА — только куда ушло и какие боты покрыты. Персональная ссылка одноразовая и привязывает к брони тот чат, который её открыл: показ ссылки менеджеру и есть перехват, потому что первое, что с ней сделают, — нажмут «проверить».
 *
 * Тела у запроса нет: что именно отправить, решает сервер. «Почему» здесь тоже не требуется — это не правка брони, а повторная доставка того, что гостю и так причиталось.
 */
export const resendGuestLinkMutation = (options?: Partial<Options<ResendGuestLinkData>>): UseMutationOptions<ResendGuestLinkResponse, ResendGuestLinkError, Options<ResendGuestLinkData>> => {
    const mutationOptions: UseMutationOptions<ResendGuestLinkResponse, ResendGuestLinkError, Options<ResendGuestLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendGuestLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskQueueQueryKey = (options?: Options<GetTaskQueueData>) => createQueryKey('getTaskQueue', options);

/**
 * Очередь задач
 *
 * BFF-ручка: очередь того, что ждёт человека, уже сгруппирована по срочности (overdue/today/later) и отсортирована — фронт не группирует и не сортирует сам.
 *
 * ⚠️ Отбора «мои / без исполнителя» здесь НЕТ и быть не может: исполнителей в системе не существует вовсе — задачу нельзя ни назначить, ни забрать. Очередь у компании ОДНА, общая, и разбирают её сверху вниз. Пока такой отбор был, вкладка «Мои» отвечала пустотой всегда, а «Без исполнителя» повторяла «Все» — интерфейс обещал распределение работы, которого нет.
 */
export const getTaskQueueOptions = (options?: Options<GetTaskQueueData>) => queryOptions<GetTaskQueueResponse, GetTaskQueueError, GetTaskQueueResponse, ReturnType<typeof getTaskQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaskQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskQueueQueryKey(options)
});

export const getTaskQueueInfiniteQueryKey = (options?: Options<GetTaskQueueData>): QueryKey<Options<GetTaskQueueData>> => createQueryKey('getTaskQueue', options, true);

/**
 * Очередь задач
 *
 * BFF-ручка: очередь того, что ждёт человека, уже сгруппирована по срочности (overdue/today/later) и отсортирована — фронт не группирует и не сортирует сам.
 *
 * ⚠️ Отбора «мои / без исполнителя» здесь НЕТ и быть не может: исполнителей в системе не существует вовсе — задачу нельзя ни назначить, ни забрать. Очередь у компании ОДНА, общая, и разбирают её сверху вниз. Пока такой отбор был, вкладка «Мои» отвечала пустотой всегда, а «Без исполнителя» повторяла «Все» — интерфейс обещал распределение работы, которого нет.
 */
export const getTaskQueueInfiniteOptions = (options?: Options<GetTaskQueueData>) => {
    const opts = infiniteQueryOptions<GetTaskQueueResponse, GetTaskQueueError, InfiniteData<GetTaskQueueResponse>, QueryKey<Options<GetTaskQueueData>>, Cursor | Pick<QueryKey<Options<GetTaskQueueData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetTaskQueueData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getTaskQueue({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTaskQueueInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Выполнить действие по задаче
 *
 * Закрывает задачу выбранным действием — подтвердить, отклонить, отметить выполненным, назвать сумму. Тело — то же `BookingActionRequest`, что у действия в карточке брони: ⚠️ «почему» обязательно у КАЖДОГО действия (3.2), без него сервер операцию не выполнит.
 *
 * ⚠️ ПОЧЕМУ ЭТО НЕ `POST /bookings/{id}/actions/{key}`, хотя действие принадлежит брони. У сценария бывают ПАРАЛЛЕЛЬНЫЕ ветки (1.5), а значит одна бронь может одновременно стоять на двух ручных шагах — и оба предложат, скажем, «Подтвердить». По одному ключу действия сервер не разобрал бы, какой из них закрывают; `taskId` называет шаг однозначно. Тело и семантика при этом общие намеренно: одно и то же нажатие в очереди и в карточке обязано отправлять одно и то же.
 *
 * Повторный вызов на уже разобранной задаче — не ошибка: два менеджера могут нажать одновременно, и второй получает тот же ответ. Разобранная задача пропадает из очереди, а `resolvedToday` учтёт её при следующем чтении.
 */
export const runTaskActionMutation = (options?: Partial<Options<RunTaskActionData>>): UseMutationOptions<RunTaskActionResponse, RunTaskActionError, Options<RunTaskActionData>> => {
    const mutationOptions: UseMutationOptions<RunTaskActionResponse, RunTaskActionError, Options<RunTaskActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runTaskAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConversationsQueryKey = (options?: Options<ListConversationsData>) => createQueryKey('listConversations', options);

/**
 * Список переписок
 *
 * Страница списка. Ответ — конверт, а не голый массив: у списка есть продолжение (курсор) и счётчик по всей выборке, а массив не может нести ни того, ни другого.
 */
export const listConversationsOptions = (options?: Options<ListConversationsData>) => queryOptions<ListConversationsResponse, ListConversationsError, ListConversationsResponse, ReturnType<typeof listConversationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConversations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConversationsQueryKey(options)
});

export const listConversationsInfiniteQueryKey = (options?: Options<ListConversationsData>): QueryKey<Options<ListConversationsData>> => createQueryKey('listConversations', options, true);

/**
 * Список переписок
 *
 * Страница списка. Ответ — конверт, а не голый массив: у списка есть продолжение (курсор) и счётчик по всей выборке, а массив не может нести ни того, ни другого.
 */
export const listConversationsInfiniteOptions = (options?: Options<ListConversationsData>) => {
    const opts = infiniteQueryOptions<ListConversationsResponse, ListConversationsError, InfiniteData<ListConversationsResponse>, QueryKey<Options<ListConversationsData>>, Cursor | Pick<QueryKey<Options<ListConversationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListConversationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listConversations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConversationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listTriageQueryKey = (options?: Options<ListTriageData>) => createQueryKey('listTriage', options);

/**
 * Непривязанные входящие («разбор»)
 *
 * Сообщения из чатов, которые система не смогла связать ни с одной бронью (3.4): канал, от кого, текст, время. Очередь наполняется сама и БЕЗ участия менеджера — в том числе его собственной кнопкой «ссылка на бота»: открытие обычной ссылки не резолвится в бронь и порождает здесь строку (3.5). Поэтому у записи два равноправных исхода, и «закрыть» — не менее частый, чем «привязать».
 */
export const listTriageOptions = (options?: Options<ListTriageData>) => queryOptions<ListTriageResponse, ListTriageError, ListTriageResponse, ReturnType<typeof listTriageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTriage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTriageQueryKey(options)
});

export const listTriageInfiniteQueryKey = (options?: Options<ListTriageData>): QueryKey<Options<ListTriageData>> => createQueryKey('listTriage', options, true);

/**
 * Непривязанные входящие («разбор»)
 *
 * Сообщения из чатов, которые система не смогла связать ни с одной бронью (3.4): канал, от кого, текст, время. Очередь наполняется сама и БЕЗ участия менеджера — в том числе его собственной кнопкой «ссылка на бота»: открытие обычной ссылки не резолвится в бронь и порождает здесь строку (3.5). Поэтому у записи два равноправных исхода, и «закрыть» — не менее частый, чем «привязать».
 */
export const listTriageInfiniteOptions = (options?: Options<ListTriageData>) => {
    const opts = infiniteQueryOptions<ListTriageResponse, ListTriageError, InfiniteData<ListTriageResponse>, QueryKey<Options<ListTriageData>>, Cursor | Pick<QueryKey<Options<ListTriageData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTriageData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTriage({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTriageInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Привязать входящее к брони
 *
 * ⚠️ НЕОБРАТИМО И ШИРЕ, ЧЕМ ВЫГЛЯДИТ: привязывается не сообщение, а ЧАТ — и с бронью навсегда (3.4). Поэтому привязывать можно только чат ГОСТЯ. Если строку породила своя же ссылка на бота, чат принадлежит менеджеру, и привязка отдала бы ему панель гостя — такие записи закрывают (см. ConversationTriageClose). Интерфейс обязан назвать это последствие ДО нажатия, а не показывать ошибку после (0.5).
 */
export const attachTriageEntryMutation = (options?: Partial<Options<AttachTriageEntryData>>): UseMutationOptions<AttachTriageEntryResponse, AttachTriageEntryError, Options<AttachTriageEntryData>> => {
    const mutationOptions: UseMutationOptions<AttachTriageEntryResponse, AttachTriageEntryError, Options<AttachTriageEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachTriageEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Закрыть запись разбора, не привязывая её
 *
 * Убрать строку из очереди БЕЗ привязки к брони. Это основной путь для записей, порождённых кнопкой «ссылка на бота» самого менеджера: спека называет его прямо — «её нужно закрыть, а не привязывать» (3.5).
 * ⚠️ БЕЗ ЭТОЙ ОПЕРАЦИИ ЭКРАН НЕВОЗМОЖЕН. Единственным действием осталась бы привязка, то есть очередь от собственного шума чистилась бы только тем действием, которое к этому шуму применять нельзя, — и каждая проверка «жив ли бот» оставляла бы неубираемую строку.
 */
export const closeTriageEntryMutation = (options?: Partial<Options<CloseTriageEntryData>>): UseMutationOptions<CloseTriageEntryResponse, CloseTriageEntryError, Options<CloseTriageEntryData>> => {
    const mutationOptions: UseMutationOptions<CloseTriageEntryResponse, CloseTriageEntryError, Options<CloseTriageEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await closeTriageEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConversationQueryKey = (options: Options<GetConversationData>) => createQueryKey('getConversation', options);

/**
 * Карточка переписки
 *
 * BFF-ручка: шапка чата одним ответом — гость, канал, режим (менеджер/ИИ), черновик ИИ (если есть), привязанная бронь, ответственный. Лента сообщений — отдельная ручка, см. /conversations/{conversationId}/timeline.
 */
export const getConversationOptions = (options: Options<GetConversationData>) => queryOptions<GetConversationResponse, GetConversationError, GetConversationResponse, ReturnType<typeof getConversationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationQueryKey(options)
});

export const getConversationTimelineQueryKey = (options: Options<GetConversationTimelineData>) => createQueryKey('getConversationTimeline', options);

/**
 * Лента переписки
 *
 * Единый поток брони, МУЛЬТИканальный: сообщения (из WhatsApp, бота, SMS, веба — у каждого свой channel), события брони, системные записи (system, с раскрываемым detail), свёрнутые технические группы (tech) и разделители дней идут вперемешку в items, уже в правильном порядке. Фронт не группирует сам — рисует список, разбирая по discriminator-полю type. У сообщения может быть attachment — рисуем строго то, что прислано.
 */
export const getConversationTimelineOptions = (options: Options<GetConversationTimelineData>) => queryOptions<GetConversationTimelineResponse, GetConversationTimelineError, GetConversationTimelineResponse, ReturnType<typeof getConversationTimelineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversationTimeline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationTimelineQueryKey(options)
});

export const getConversationTimelineInfiniteQueryKey = (options: Options<GetConversationTimelineData>): QueryKey<Options<GetConversationTimelineData>> => createQueryKey('getConversationTimeline', options, true);

/**
 * Лента переписки
 *
 * Единый поток брони, МУЛЬТИканальный: сообщения (из WhatsApp, бота, SMS, веба — у каждого свой channel), события брони, системные записи (system, с раскрываемым detail), свёрнутые технические группы (tech) и разделители дней идут вперемешку в items, уже в правильном порядке. Фронт не группирует сам — рисует список, разбирая по discriminator-полю type. У сообщения может быть attachment — рисуем строго то, что прислано.
 */
export const getConversationTimelineInfiniteOptions = (options: Options<GetConversationTimelineData>) => {
    const opts = infiniteQueryOptions<GetConversationTimelineResponse, GetConversationTimelineError, InfiniteData<GetConversationTimelineResponse>, QueryKey<Options<GetConversationTimelineData>>, Cursor | Pick<QueryKey<Options<GetConversationTimelineData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetConversationTimelineData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getConversationTimeline({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getConversationTimelineInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Отправить сообщение гостю
 *
 * Сообщение уходит гостю выбранным каналом (channelKind — род из ConversationDetail.sendChannels с available=true; без него сервер берёт канал по умолчанию, ConversationDetail.channel). Отправка необратима — отсюда обязательный Idempotency-Key: повтор с тем же ключом в пределах суток не продублирует сообщение гостю. В ответ приходит TimelineMessage, который фронт сразу вставляет в ленту — изначально со статусом доставки sending (deliveryStatus), дальше статус обновляется поллингом /conversations/{conversationId}/timeline.
 */
export const sendMessageMutation = (options?: Partial<Options<SendMessageData>>): UseMutationOptions<SendMessageResponse, SendMessageError, Options<SendMessageData>> => {
    const mutationOptions: UseMutationOptions<SendMessageResponse, SendMessageError, Options<SendMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отправить черновик ИИ как есть
 *
 * Уходит ровно тот черновик, который видел менеджер, — `draftId`. Между чтением переписки и кликом ИИ может заменить черновик более новым, и по клику на старый не должен уйти текст, которого менеджер не читал: черновик, который больше не ждёт решения, отвечает 409, и по этому клику гостю не уходит ничего. Править черновик нельзя — для этого переписку переводят в режим manager и отправляют текст обычным sendMessage.
 *
 * Сообщение уходит тем же каналом, что sendMessage без channelKind, ложится в ленту сообщением ИИ, и дальше переписку ведёт менеджер (mode — manager).
 *
 * ⚠️ Idempotency-Key у ручки НЕТ, и это не пропуск. Черновик, который сервер отметил отправленным, второй раз не уйдёт и без него: сервер захватывает черновик перед отправкой, и повтор получает 409. После неудачной отправки (422) черновик, если его не заменили, снова ждёт, и повтор с тем же draftId отправит его заново.
 */
export const sendAiDraftMutation = (options?: Partial<Options<SendAiDraftData>>): UseMutationOptions<SendAiDraftResponse, SendAiDraftError, Options<SendAiDraftData>> => {
    const mutationOptions: UseMutationOptions<SendAiDraftResponse, SendAiDraftError, Options<SendAiDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendAiDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отклонить черновик ИИ
 *
 * Отклоняется ровно тот черновик, который видел менеджер, — `draftId`: более новый, которого он не видел, этот вызов не трогает. 204 — и тогда, когда черновика с этим id среди ожидающих уже нет: отклонять нечего, и это не ошибка.
 */
export const dismissAiDraftMutation = (options?: Partial<Options<DismissAiDraftData>>): UseMutationOptions<DismissAiDraftResponse, DismissAiDraftError, Options<DismissAiDraftData>> => {
    const mutationOptions: UseMutationOptions<DismissAiDraftResponse, DismissAiDraftError, Options<DismissAiDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dismissAiDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Переключить режим переписки — менеджер/ИИ
 *
 * Переключение на manager автоматически отклоняет висящий черновик ИИ (ConversationDetail.aiDraft), если он есть, — менеджер взял диалог на себя, и предложение ИИ протухло. Переключение на ai черновик не создаёт: он появится сам, когда ответит гость.
 */
export const setConversationModeMutation = (options?: Partial<Options<SetConversationModeData>>): UseMutationOptions<SetConversationModeResponse, SetConversationModeError, Options<SetConversationModeData>> => {
    const mutationOptions: UseMutationOptions<SetConversationModeResponse, SetConversationModeError, Options<SetConversationModeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setConversationMode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getScenarioCatalogQueryKey = (options?: Options<GetScenarioCatalogData>) => createQueryKey('getScenarioCatalog', options);

/**
 * Каталог типов шага движка сценариев
 *
 * Каталог движка сценариев (catalog_json) — единственный источник истины для палитры и инспектора. Фронт НИЧЕГО не хардкодит: типы блоков (`blocks: BlockManifest[]`), их поля (`fields[]` — схема инспектора, где `field.path` = ключ в `config`), исходы, факты, события, способы оплаты, операторы и `capabilities` приходят отсюда. Значение поля пишется под `config[field.path]`, и конфиг валиден by construction — никакого params→config перевода. Доступность блока в палитре = `enabled || safeWhenDisabled`. Форма ответа — в схеме `ScenarioCatalog` (см. docs/flowengine-builder-api.md, § GetBuilderCatalog); именно её должен вернуть gateway.
 */
export const getScenarioCatalogOptions = (options?: Options<GetScenarioCatalogData>) => queryOptions<GetScenarioCatalogResponse, GetScenarioCatalogError, GetScenarioCatalogResponse, ReturnType<typeof getScenarioCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getScenarioCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getScenarioCatalogQueryKey(options)
});

export const listScenariosQueryKey = (options?: Options<ListScenariosData>) => createQueryKey('listScenarios', options);

/**
 * Список сценариев
 */
export const listScenariosOptions = (options?: Options<ListScenariosData>) => queryOptions<ListScenariosResponse, ListScenariosError, ListScenariosResponse, ReturnType<typeof listScenariosQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listScenarios({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listScenariosQueryKey(options)
});

/**
 * Создать пустой сценарий
 *
 * Заводит новый сценарий с именем по умолчанию и уже посаженным стартовым блоком-триггером. Совсем пустым граф быть не может: ScenarioGraph.startBlockId обязан присутствовать среди nodes, а блоки-триггеры в палитру не попадают — их сажает сервер. Тела нет: имя правится потом через PATCH /scenarios/{scenarioId}. Ответ — созданный Scenario целиком (draft, issues, readyToPublish), как у getScenario: свежий сценарий честно открывается с проблемами «дострой граф», а не «зелёным».
 */
export const createScenarioMutation = (options?: Partial<Options<CreateScenarioData>>): UseMutationOptions<CreateScenarioResponse, CreateScenarioError, Options<CreateScenarioData>> => {
    const mutationOptions: UseMutationOptions<CreateScenarioResponse, CreateScenarioError, Options<CreateScenarioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createScenario({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Создать сценарий из шаблона
 */
export const createScenarioFromTemplateMutation = (options?: Partial<Options<CreateScenarioFromTemplateData>>): UseMutationOptions<CreateScenarioFromTemplateResponse, CreateScenarioFromTemplateError, Options<CreateScenarioFromTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateScenarioFromTemplateResponse, CreateScenarioFromTemplateError, Options<CreateScenarioFromTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createScenarioFromTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Удалить сценарий
 *
 * Удаляет сценарий вместе с его черновиком. Сервер сам снимает ссылки на него из маршрута: правила с ним пропадают, а `defaultTarget`, если он указывал на этот сценарий, становится `null` — «автоматизации нет». Подставлять вместо удалённого «первый попавшийся» нельзя: это увело бы все новые брони в чужой сценарий, и никто бы этого не заметил.
 */
export const deleteScenarioMutation = (options?: Partial<Options<DeleteScenarioData>>): UseMutationOptions<DeleteScenarioResponse, DeleteScenarioError, Options<DeleteScenarioData>> => {
    const mutationOptions: UseMutationOptions<DeleteScenarioResponse, DeleteScenarioError, Options<DeleteScenarioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteScenario({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getScenarioQueryKey = (options: Options<GetScenarioData>) => createQueryKey('getScenario', options);

/**
 * Карточка сценария
 *
 * Включает текущий черновик (draft) целиком — граф узлов и связей — и issues (проблемы валидации графа, их считает сервер: он знает семантику движка, включая условия, параллельные ветки и слияния).
 */
export const getScenarioOptions = (options: Options<GetScenarioData>) => queryOptions<GetScenarioResponse, GetScenarioError, GetScenarioResponse, ReturnType<typeof getScenarioQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getScenario({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getScenarioQueryKey(options)
});

/**
 * Переименовать сценарий
 *
 * Меняет ТОЛЬКО отображаемое имя. Граф, версия и draftVersion не трогаются — автосейв продолжает работать с тем же If-Match, конфликта версий rename не создаёт. Ответ — обновлённый Scenario.
 */
export const renameScenarioMutation = (options?: Partial<Options<RenameScenarioData>>): UseMutationOptions<RenameScenarioResponse, RenameScenarioError, Options<RenameScenarioData>> => {
    const mutationOptions: UseMutationOptions<RenameScenarioResponse, RenameScenarioError, Options<RenameScenarioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renameScenario({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Сохранить черновик графа (автосейв)
 *
 * Полная замена графа черновика — тело ScenarioGraph. Требует If-Match с текущим Scenario.draftVersion: сервер меняет версию на каждое сохранение, и если версия в заголовке разошлась с текущей (кто-то другой уже сохранил более новую), отвечает 409 — чужие правки не затираем. Актуальная версия в этом случае приезжает в поле currentVersion расширенной схемы 409-ответа (см. ниже) — это отдельный extension member по RFC 9457, а не Problem.detail: detail свободный текст для человека, а не поле для парсинга. По currentVersion фронт показывает конфликт и предлагает перезагрузить черновик.
 */
export const saveScenarioDraftMutation = (options?: Partial<Options<SaveScenarioDraftData>>): UseMutationOptions<SaveScenarioDraftResponse, SaveScenarioDraftError, Options<SaveScenarioDraftData>> => {
    const mutationOptions: UseMutationOptions<SaveScenarioDraftResponse, SaveScenarioDraftError, Options<SaveScenarioDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveScenarioDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Опубликовать черновик
 *
 * Текущий черновик (draft) становится действующей версией сценария. Ответ — обновлённый Scenario: version и status отражают новое опубликованное состояние, draft остаётся доступным для дальнейшего редактирования.
 */
export const publishScenarioMutation = (options?: Partial<Options<PublishScenarioData>>): UseMutationOptions<PublishScenarioResponse, PublishScenarioError, Options<PublishScenarioData>> => {
    const mutationOptions: UseMutationOptions<PublishScenarioResponse, PublishScenarioError, Options<PublishScenarioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishScenario({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Проверка пути по текущему черновику
 *
 * Прогоняет сценарий по шагам и показывает, каким путём пойдёт бронь (1.11). НИЧЕГО реального не происходит: сообщения не уходят, платежи не создаются, памятки не открываются, бронь не создаётся — ответ лишь перечисляет команды, которые БЫЛИ БЫ отправлены.
 * Путь по графу знает только движок (условия, параллельные ветки, слияния), поэтому фронт его не эмулирует: он задаёт начальные данные и последовательность входов, а рисует присланное.
 * ⚠️ Часов у прогона нет — сам по себе ни один срок не наступит. Но срок это такой же вход, и ответ САМ перечисляет свои сроки с готовыми подписями: интерфейсу остаётся нарисовать список и дать по нему нажать, ничего не придумывая.
 */
export const dryRunScenarioMutation = (options?: Partial<Options<DryRunScenarioData>>): UseMutationOptions<DryRunScenarioResponse, DryRunScenarioError, Options<DryRunScenarioData>> => {
    const mutationOptions: UseMutationOptions<DryRunScenarioResponse, DryRunScenarioError, Options<DryRunScenarioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dryRunScenario({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Проверить черновик графа (живая валидация движком)
 *
 * Живая статическая проверка ПЕРЕДАННОГО в теле графа-черновика — без сохранения и без версий. Фронт зовёт её на каждое изменение графа (с дебаунсом), чтобы показывать проблемы сразу: пустая сумма/процент, тупики, недостижимые шаги, дубли связей и т.п. Семантику движка (условия, параллели, слияния, подключённость сервисов) знает только сервер — фронт ничего не вычисляет сам, а раскладывает готовые проблемы по местам (см. ScenarioIssue: nodeId/fieldKey/edgeId и признак «весь граф»). Тело — тот же ScenarioGraph, что уходит в автосейв; scenarioId в пути задаёт контекст (компанию, подключённые сервисы), сам граф берётся из тела, а не из сохранённого черновика.
 */
export const validateScenarioMutation = (options?: Partial<Options<ValidateScenarioData>>): UseMutationOptions<ValidateScenarioResponse, ValidateScenarioError, Options<ValidateScenarioData>> => {
    const mutationOptions: UseMutationOptions<ValidateScenarioResponse, ValidateScenarioError, Options<ValidateScenarioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateScenario({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getScenarioBotMapQueryKey = (options: Options<GetScenarioBotMapData>) => createQueryKey('getScenarioBotMap', options);

/**
 * Карта бота — что увидит гость
 *
 * Собирается сервером ИЗ ТЕКУЩЕГО ЧЕРНОВИКА сценария, поэтому не может разойтись с тем, что бот покажет на самом деле (1.12). Только просмотр: второго редактора бота нет и не будет — он разошёлся бы с реальностью молча (6.12).
 * Считается по тому же графу, что лежит в черновике, — отдельного тела запроса нет. Если в сценарии есть ошибки, ответ приходит с `assembled: false` и списком проблем: карту в таком состоянии собрать нечем, и это нормальный ответ, а не сбой.
 */
export const getScenarioBotMapOptions = (options: Options<GetScenarioBotMapData>) => queryOptions<GetScenarioBotMapResponse, GetScenarioBotMapError, GetScenarioBotMapResponse, ReturnType<typeof getScenarioBotMapQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getScenarioBotMap({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getScenarioBotMapQueryKey(options)
});

export const listScenarioTemplatesQueryKey = (options?: Options<ListScenarioTemplatesData>) => createQueryKey('listScenarioTemplates', options);

/**
 * Готовые шаблоны сценариев
 */
export const listScenarioTemplatesOptions = (options?: Options<ListScenarioTemplatesData>) => queryOptions<ListScenarioTemplatesResponse, ListScenarioTemplatesError, ListScenarioTemplatesResponse, ReturnType<typeof listScenarioTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listScenarioTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listScenarioTemplatesQueryKey(options)
});

export const getPolicyQueryKey = (options?: Options<GetPolicyData>) => createQueryKey('getPolicy', options);

/**
 * Маршрут новых броней
 *
 * Правила, по которым новая бронь получает сценарий: условие → сценарий и КОНКРЕТНАЯ его версия, проверяются по порядку сверху вниз, срабатывает первое подошедшее; `defaultTarget` — кому не подошло ни одно. Плюс `availableScenarios` — что вообще можно выбрать (только опубликованные версии) и сколько броней идёт по каждой прямо сейчас.
 */
export const getPolicyOptions = (options?: Options<GetPolicyData>) => queryOptions<GetPolicyResponse, GetPolicyError, GetPolicyResponse, ReturnType<typeof getPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPolicyQueryKey(options)
});

/**
 * Сохранить маршрут новых броней
 *
 * Полная замена правил и «всем остальным». Порядок правил сохраняется как прислан — он логика (первое подошедшее срабатывает), а не оформление. Цель каждого правила обязана указывать на ОПУБЛИКОВАННУЮ версию: черновик гостям не показывается, поэтому такой запрос отклоняется (1.13.4).
 */
export const savePolicyMutation = (options?: Partial<Options<SavePolicyData>>): UseMutationOptions<SavePolicyResponse, SavePolicyError, Options<SavePolicyData>> => {
    const mutationOptions: UseMutationOptions<SavePolicyResponse, SavePolicyError, Options<SavePolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await savePolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listContentQueryKey = (options?: Options<ListContentData>) => createQueryKey('listContent', options);

/**
 * Список шаблонов контента
 *
 * Библиотека текстов: экран, где менеджер пишет, правит и вводит в работу. Без blocks — см. ContentRow (полный шаблон по одному — getContent). Без `kind` вернутся все виды (instruction|message|agreement); с `kind` — только один вид.
 *
 * ⚠️ ЭТО НЕ ИСТОЧНИК ДЛЯ ПИКЕРА В ШАГЕ СЦЕНАРИЯ — для него есть `listContentRoles`. Здесь строка — ЗАПИСЬ (кортеж kind/role/scope/apartmentId), и переопределение по квартире это отдельная запись С ТЕМ ЖЕ `role`. Шаг ссылается на роль, а какое переопределение получит гость, решается при рендере ПО КАЖДОЙ БРОНИ — значит в выборе шага квартирных записей быть не может: это варианты, которые сценарий выразить не способен. Пока пикер строился отсюда, компания с переопределением на каждой квартире видела в нём один и тот же текст столько раз, сколько у неё квартир.
 *
 * ⚠️ Не фильтровать по `status == published` и не адресовать строку по `version`: `id` называет ту запись, которую менеджер ОТКРЫВАЕТ, — черновик, если он есть, иначе рабочую версию.
 */
export const listContentOptions = (options?: Options<ListContentData>) => queryOptions<ListContentResponse, ListContentError, ListContentResponse, ReturnType<typeof listContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentQueryKey(options)
});

/**
 * Создать шаблон контента
 *
 * Заводит новый шаблон-черновик выбранного вида (kind) с пустым телом. Форма домена одна (blocks[]), поэтому редактор/превью/сохранение у всех видов общие. Блоки автор правит сразу в редакторе (PUT saveContent). Без тела/поля kind создаётся instruction. Ответ — ContentItem.
 *
 * ⚠️ ТЕКСТ ЗАВОДИТСЯ ПО НАЗВАНИЮ, идентификатор мнёт СЕРВЕР. Название гость читает на кнопке в боте, а идентификатор не должен видеть никто (2.2) — спрашивать его при создании значило бы начинать работу с поля, смысл которого менеджеру объяснить нельзя. Разницы между «создать памятку Wi-Fi из готовых» и «создать новую и назвать Wi-Fi» нет никакой (2.1): в обоих случаях приходит title, во втором дополнительно приходит role готовой памятки.
 */
export const createContentMutation = (options?: Partial<Options<CreateContentData>>): UseMutationOptions<CreateContentResponse, CreateContentError, Options<CreateContentData>> => {
    const mutationOptions: UseMutationOptions<CreateContentResponse, CreateContentError, Options<CreateContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContentAuthoringCatalogQueryKey = (options?: Options<GetContentAuthoringCatalogData>) => createQueryKey('getContentAuthoringCatalog', options);

/**
 * Каталог авторинга контента
 *
 * Единственный источник для палитры подстановок (факты · переменные квартиры · секреты · ссылки) и пикера ролей. Аналог GET /scenarios/catalog: фронт ничего не хардкодит — какие токены и роли существуют, знает сервер. Новый ключ или роль не требуют деплоя фронта.
 */
export const getContentAuthoringCatalogOptions = (options?: Options<GetContentAuthoringCatalogData>) => queryOptions<GetContentAuthoringCatalogResponse, GetContentAuthoringCatalogError, GetContentAuthoringCatalogResponse, ReturnType<typeof getContentAuthoringCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentAuthoringCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentAuthoringCatalogQueryKey(options)
});

export const listContentRolesQueryKey = (options: Options<ListContentRolesData>) => createQueryKey('listContentRoles', options);

/**
 * На что может сослаться шаг сценария
 *
 * Роли выбранного вида — ОДНА запись на роль, независимо от того, сколько у неё версий и квартирных переопределений. Это единственный источник для пикера текста в шаге сценария.
 * Вопрос здесь другой, чем у `listContent`, и путать их нельзя. Библиотека отвечает «какие тексты есть у компании» (там правят и вводят в работу, там же живут переопределения по квартирам). Эта ручка отвечает «на что может сослаться ШАГ» — а шаг знает только роль: версию и квартирное переопределение выбирает рендер по каждой брони.
 *
 * ⚠️ И это НЕ `ContentAuthoringCatalog.roles`. Там — «что можно СОЗДАТЬ» (встроенные роли, в том числе те, по которым ещё ничего не написано). Здесь — «на что можно СОСЛАТЬСЯ» с признаками пригодности. Разные вопросы: первый нужен при заведении текста, второй — при выборе в шаге.
 *
 * Квартиры параметром НЕТ намеренно. Сценарий общий для компании, и роль, опубликованная только как переопределение одной квартиры, для всех остальных действительно отсутствует — она и должна прийти как `published: false`. Параметр появится, если заведём экран «а что получит гость ИМЕННО этой квартиры»; сейчас такого вопроса не задаёт ни один экран.
 */
export const listContentRolesOptions = (options: Options<ListContentRolesData>) => queryOptions<ListContentRolesResponse, ListContentRolesError, ListContentRolesResponse, ReturnType<typeof listContentRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentRolesQueryKey(options)
});

/**
 * Пригодны ли роли, на которые ссылается сценарий
 *
 * Ответ на вопрос «можно ли положиться на текст, к которому ведёт шаг» — для ролей, которые спрашивающий уже знает. Считается ТОЙ ЖЕ функцией, что и `listContentRoles`: выбор в шаге не должен предлагать то, что проверка потом отвергнет, а два независимых ответа на один вопрос однажды разойдутся. Это и есть причина, по которой ручка отдельная, а не «посчитайте сами по библиотеке»: библиотека отвечает про ЗАПИСИ, а шаг ссылается на РОЛЬ.
 * Соединять с разбором сценария по `role` и вешать ответ на шаг — так «этот шаг открывает памятку, которой нет» доходит до менеджера раньше, чем гость нажмёт кнопку.
 *
 * POST при том, что это чтение: ролей бывает до 500, и в строке запроса им тесно. Тот же приём, что у проверки графа сценария.
 *
 * Квартиры в запросе НЕТ намеренно — по той же причине, что и у `listContentRoles`: сценарий общий для компании, и роль, введённая в работу только переопределением одной квартиры, для всех остальных броней действительно отсутствует. Спросить «а что получит гость ИМЕННО этой квартиры» — другой вопрос, и такого экрана у нас пока нет.
 */
export const listContentRoleStatusMutation = (options?: Partial<Options<ListContentRoleStatusData>>): UseMutationOptions<ListContentRoleStatusResponse, ListContentRoleStatusError, Options<ListContentRoleStatusData>> => {
    const mutationOptions: UseMutationOptions<ListContentRoleStatusResponse, ListContentRoleStatusError, Options<ListContentRoleStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await listContentRoleStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Удалить текст
 *
 * Сносит запись целиком и сразу — черновик и все её версии, без дрейна. Шаг сценария, ссылавшийся на эту роль, останется с висящей ссылкой: гость нажмёт кнопку, которая ничего не откроет.
 *
 * ⚠️ РАДИУС ЗАВИСИТ ОТ ОБЛАСТИ ЗАПИСИ, и это не тонкость, а два разных действия интерфейса. Удаление ОБЩЕЙ записи сносит роль у компании ЦЕЛИКОМ — вместе со своими текстами квартир: оставить их значило бы, что менеджер удалил текст, а гости нескольких квартир продолжают его получать. Удаление записи КВАРТИРЫ снимает только её — квартира возвращается к общему тексту («убрать свой текст квартиры»), и на остальные это не влияет.
 *
 * Прежняя формулировка («сносит всю роль») описывала только первый случай, и второй под неё не подпадал вовсе — то есть операция «убрать свой текст квартиры» контрактом не выражалась.
 */
export const deleteContentMutation = (options?: Partial<Options<DeleteContentData>>): UseMutationOptions<DeleteContentResponse, DeleteContentError, Options<DeleteContentData>> => {
    const mutationOptions: UseMutationOptions<DeleteContentResponse, DeleteContentError, Options<DeleteContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContentQueryKey = (options: Options<GetContentData>) => createQueryKey('getContent', options);

/**
 * Карточка шаблона контента
 *
 * Полный текст с частями, проверками (issues) и списком мест, откуда он попадает гостю (usage). ⚠️ Ошибки из issues БЛОКИРУЮТ ввод в работу; предупреждения — нет.
 */
export const getContentOptions = (options: Options<GetContentData>) => queryOptions<GetContentResponse, GetContentError, GetContentResponse, ReturnType<typeof getContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentQueryKey(options)
});

/**
 * Сохранить черновик текста
 *
 * Полная замена тела (upsert черновика). ⚠️ Сохранение НЕ ПРОВЕРЯЕТ НИЧЕГО (2.4) — черновик можно оставить в любом состоянии; проверки выполняются при вводе в работу. Пересчитанные issues в ответе приходят как подсказка автору, а не как условие сохранения.
 * Клиент возвращает `revision` таким, каким прочитал (6.10).
 *
 * ⚠️ ЭТО PUT ЦЕЛОГО ДОКУМЕНТА, И ЧАСТИЧНОЕ ТЕЛО — НЕ «НЕ ТРОГАТЬ ОСТАЛЬНОЕ», А ОТКАЗ. `blocks` — обязательное поле `ContentDocument`, поэтому тело без него невалидно по контракту, и применять его нельзя НИ КАК полную замену (это молча стёрло бы весь текст), НИ КАК частичную правку (такой семантики у операции нет). Правильный ответ — `422`, до записи.
 *
 * ⚠️ ТЕЛО — `ContentDocument`, А ОТВЕТ — `ContentItem`, И РАЗВЕЛИ ИХ НЕ ДЛЯ ПОРЯДКА. Из полей ответа СЕМЬ приставляются на выходе и на документе их нет вовсе, а `status` и `version` на документе есть, но принадлежат серверу: сохранение затирает присланное. Разбор — у самой схемы. Пока схема была ОДНА, контракт формально требовал прислать в теле русскую ФРАЗУ `deliveryLabel` — то есть завести ровно тот приватный словарь, ради сноса которого поле и просили.
 * Клиент по-прежнему шлёт документ таким, каким прочитал, и выводные поля в теле оказываются: лишние свойства схема не запрещает. Но теперь это ЕГО дело, а не требование контракта, — и первый же путь, собирающий тело не из прочитанной записи, ни во что не упрётся.
 * Отдельной ручки «дописать блок» нет намеренно: порядок блоков — часть смысла текста, и частичные правки поверх чужого порядка расходятся молча. Интерфейс всегда шлёт документ целиком — тем самым, каким его прочитал.
 */
export const saveContentMutation = (options?: Partial<Options<SaveContentData>>): UseMutationOptions<SaveContentResponse, SaveContentError, Options<SaveContentData>> => {
    const mutationOptions: UseMutationOptions<SaveContentResponse, SaveContentError, Options<SaveContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ввести текст в работу
 *
 * Переводит черновик в рабочее состояние — то, что получает гость. ⚠️ НЕ создаёт копию и НЕ меняет номер версии (2.4): меняется состояние записи. Следующая правка заведёт новый черновик, а рабочая версия останется жить — и гость будет получать её, пока новый черновик не введут в работу.
 * ⚠️ Блокируют ТОЛЬКО ошибки. Предупреждения приходят ВМЕСТЕ с успешным ответом, а не вместо него: иначе их не увидел бы никто.
 * Что НЕ проверяется и спокойно вводится в работу (2.4): пустая ТЕКСТОВАЯ часть, неправильные адреса ссылок, отсутствие названия и идентификатора — гость получит «Здесь пока пусто.» Отсутствие частей вовсе при этом проверкой является и вводу в работу мешает.
 * ⚠️ Требует `revision` — тот, что клиент прочитал (6.10). Без него один менеджер показал бы гостям черновик, который писал другой и ещё не считает готовым: правка ушла бы наружу, а увидели бы её только гости.
 */
export const publishContentMutation = (options?: Partial<Options<PublishContentData>>): UseMutationOptions<PublishContentResponse, PublishContentError, Options<PublishContentData>> => {
    const mutationOptions: UseMutationOptions<PublishContentResponse, PublishContentError, Options<PublishContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Превью шаблона под канал
 *
 * Рендерит сервер под конкретный канал — он знает правила leak-safe (секреты в SMS уходят только ссылкой, не значением) и подстановку токенов. Текст приходит сегментами; фронт не собирает превью сам из blocks.
 *
 * ⚠️ ПОЧЕМУ POST, ЕСЛИ ЭТО ЧТЕНИЕ. Потому что превью обязано отвечать про то, что автор пишет СЕЙЧАС, а несохранённое тело помещается только в тело запроса. Пока ручка была `GET` по идентификатору, и рендер, и замечания описывали ПОСЛЕДНЕЕ СОХРАНЁННОЕ состояние: про слишком длинный ключ критерия автор узнавал уже после «Сохранить», а превью рядом показывало вчерашний текст. Запрос ничего не записывает — `draft` это вход рендера, а не правка записи.
 *
 * ⚠️ ИДЕНТИФИКАТОР ОСТАЁТСЯ В ПУТИ И ОСТАЁТСЯ ОБЯЗАТЕЛЬНЫМ, даже когда тело прислано целиком. Рендер зависит не только от частей: вид, роль, область и природа доставки берутся из ЗАПИСИ — по ним решается, чем становится ссылка, какие каналы у текста есть вообще и подставлять ли данные квартиры. Ручка «только тело, без записи» отрендерить не смогла бы.
 */
export const previewContentMutation = (options?: Partial<Options<PreviewContentData>>): UseMutationOptions<PreviewContentResponse, PreviewContentError, Options<PreviewContentData>> => {
    const mutationOptions: UseMutationOptions<PreviewContentResponse, PreviewContentError, Options<PreviewContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Проверить набранное тело — без рендера
 *
 * Отвечает только замечаниями. Ничего не рисует и ничего не записывает: `draft` — вход проверки, а не правка записи.
 *
 * ⚠️ ЗАЧЕМ ОТДЕЛЬНАЯ РУЧКА, ЕСЛИ ЗАМЕЧАНИЯ ЕСТЬ У ПРЕВЬЮ. Потому что превью требует поверхность — оно про картинку. Редактору картинка не нужна, ему нужен список; спрашивая превью, он заставлял сервер рендерить в никуда и вдобавок выбирать канал там, где канал ни на что не влияет (замечания по каналу не фильтруются). Домен предложил именно эту форму: «сделать `channel` необязательным нельзя — пустая строка там уже занята историческим веб-умолчанием, и „не рендерить" сказать нечем».
 *
 * ⚠️ ИДЕНТИФИКАТОР В ПУТИ ОБЯЗАТЕЛЕН, как и у превью: `kind`, `role` и `scope` читают сами проверки, и берутся они из ЗАПИСИ. Разбор — в `ContentDraft`.
 */
export const validateContentMutation = (options?: Partial<Options<ValidateContentData>>): UseMutationOptions<ValidateContentResponse, ValidateContentError, Options<ValidateContentData>> => {
    const mutationOptions: UseMutationOptions<ValidateContentResponse, ValidateContentError, Options<ValidateContentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateContent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBrandQueryKey = (options?: Options<GetBrandData>) => createQueryKey('getBrand', options);

/**
 * Настройки бренда
 */
export const getBrandOptions = (options?: Options<GetBrandData>) => queryOptions<GetBrandResponse, GetBrandError, GetBrandResponse, ReturnType<typeof getBrandQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBrand({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBrandQueryKey(options)
});

/**
 * Сохранить настройки бренда
 */
export const saveBrandMutation = (options?: Partial<Options<SaveBrandData>>): UseMutationOptions<SaveBrandResponse, SaveBrandError, Options<SaveBrandData>> => {
    const mutationOptions: UseMutationOptions<SaveBrandResponse, SaveBrandError, Options<SaveBrandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveBrand({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listApartmentsQueryKey = (options?: Options<ListApartmentsData>) => createQueryKey('listApartments', options);

/**
 * Список апартаментов
 *
 * Без attrs — см. ApartmentRow. Полная карточка — getApartment.
 */
export const listApartmentsOptions = (options?: Options<ListApartmentsData>) => queryOptions<ListApartmentsResponse, ListApartmentsError, ListApartmentsResponse, ReturnType<typeof listApartmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApartments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApartmentsQueryKey(options)
});

export const listGatedRolesQueryKey = (options?: Options<ListGatedRolesData>) => createQueryKey('listGatedRoles', options);

/**
 * Роли инструкций, которыми закрыты коды доступа
 *
 * Какие роли служат ЗАМКОМ для кодов доступа. Нужно РЕДАКТОРУ СЦЕНАРИЯ: меняя роль у шага «Открыть инструкцию», автор меняет и то, кому придёт код, — и ни один экран об этом сегодня не говорит (ответ бекенда 23.08, §4; у них это `ListGatedRoles`).
 *
 * ⚠️ ЗАПРОС ПУСТОЙ, И ЭТО ОБЯЗАТЕЛЬНО. У них в прото первым полем идёт `company_id`; НАМ ЕГО СЛАТЬ НЕЛЬЗЯ И В КОНТРАКТЕ ЕГО БЫТЬ НЕ ДОЛЖНО — компанию ставит шлюз из сессии менеджера, он же и проверяет право. Появись это поле здесь, стало бы возможно спросить чужую компанию: сервис ему поверит, потому что проверку делает не он.
 *
 * ⚠️ ОТДЕЛЬНАЯ РУЧКА, А НЕ ПОЛЕ В КАТАЛОГЕ СЦЕНАРИЕВ. Каталог кешируется и меняется при деплое движка, а этот список меняется, когда менеджер заводит секрет, — то есть на другой частоте и в другом разделе. Спрятав его в каталог, мы получили бы предупреждение, отстающее ровно настолько, насколько живёт кеш.
 */
export const listGatedRolesOptions = (options?: Options<ListGatedRolesData>) => queryOptions<ListGatedRolesResponse, ListGatedRolesError, ListGatedRolesResponse, ReturnType<typeof listGatedRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listGatedRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listGatedRolesQueryKey(options)
});

export const getApartmentQueryKey = (options: Options<GetApartmentData>) => createQueryKey('getApartment', options);

/**
 * Карточка апартамента
 *
 * secrets содержит только факт наличия (isSet) и подпись последней выдачи (lastRevealLabel) по каждому ключу — значения секретов сюда не попадают никогда, и отдельной операции «показать» тоже нет: см. банер над ApartmentSecretEntry.
 */
export const getApartmentOptions = (options: Options<GetApartmentData>) => queryOptions<GetApartmentResponse, GetApartmentError, GetApartmentResponse, ReturnType<typeof getApartmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApartment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApartmentQueryKey(options)
});

/**
 * Переименовать секрет апартамента
 *
 * Меняет ТОЛЬКО человеческое название секрета. Значение не трогает, версию не двигает (ничего не проворачивалось), и `requiredRole` здесь НЕТ намеренно.
 *
 * ⚠️ ОТДЕЛЬНАЯ ОПЕРАЦИЯ, А НЕ ПОЛЕ В `PUT` — И ДОВОД ЗДЕСЬ НЕ ПРО ОПРЯТНОСТЬ. Название и значение задавались одним вызовом, и от этого обычная правка становилась опасной: значение не возвращается никогда, поэтому форма правки открывается ПУСТОЙ и всё набранное ЗАМЕНЯЕТ код. Чтобы исправить опечатку в НАЗВАНИИ, менеджеру приходилось вслепую перенабирать код от двери по памяти — и промах запирал гостя снаружи. Их слова: «a punishment for a spelling mistake».
 *
 * ⚠️ `requiredRole` СЮДА НЕ КЛАДЁМ по той же причине, по какой его нет у них: это сам замок. Менять, кому и когда открывается код, — намеренное действие с последствиями для доступа, а не побочный эффект наведения порядка в подписях.
 *
 * Создать секрет этим вызовом нельзя: переименовывают существующее, а для создания нужно значение, которого запрос не несёт. Нет такого секрета — `404`.
 */
export const setApartmentSecretLabelMutation = (options?: Partial<Options<SetApartmentSecretLabelData>>): UseMutationOptions<SetApartmentSecretLabelResponse, SetApartmentSecretLabelError, Options<SetApartmentSecretLabelData>> => {
    const mutationOptions: UseMutationOptions<SetApartmentSecretLabelResponse, SetApartmentSecretLabelError, Options<SetApartmentSecretLabelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setApartmentSecretLabel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Задать значение секрета апартамента
 *
 * Записывает значение — само значение в ответе не возвращается, и прочитать его потом тоже нельзя (2.9): запись здесь ОДНОСТОРОННЯЯ. Значит новое значение всегда ЗАМЕНЯЕТ прежнее вслепую, и интерфейс обязан сказать об этом до нажатия, а не показывать пустое поле как «сейчас пусто». Тело — одна из двух форм: value для одиночного секрета (код замка, код сейфа), fields для структурного (Wi-Fi — сразу оба под-поля, ssid и password).
 */
export const saveApartmentSecretMutation = (options?: Partial<Options<SaveApartmentSecretData>>): UseMutationOptions<SaveApartmentSecretResponse, SaveApartmentSecretError, Options<SaveApartmentSecretData>> => {
    const mutationOptions: UseMutationOptions<SaveApartmentSecretResponse, SaveApartmentSecretError, Options<SaveApartmentSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveApartmentSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Записать значения переменных квартиры
 *
 * Тело — карта «ключ переменной → новое значение». **Слияние, а не замена**: переданные ключи создаются или обновляются, остальные переменные этой квартиры остаются нетронутыми. Замена молча стёрла бы все незатронутые переменные квартиры — а из формы UI это выглядело бы как «я поправил адрес», и остальные данные незаметно пропали бы.
 * Отдельной ручки «создать ключ» нет: ключ появляется неявно, как только для какой-нибудь квартиры записано его значение — этим же вызовом (см. банер над ApartmentVariableEntry в components/schemas/apartment.yaml). Одна операция покрывает оба действия макета: «Изменить» у существующей переменной (один ключ в карте) и «+ добавить переменную» (новый ключ — он появится и в GET /apartment-variables). Это ровно бекенд-примитив SetApartmentVariables(apartmentId, map).
 * 404 означает только «нет такой квартиры»: ключ отдельной сущностью не является и создаётся этим же вызовом, поэтому «ключ не найден» здесь невозможен.
 */
export const setApartmentVariablesMutation = (options?: Partial<Options<SetApartmentVariablesData>>): UseMutationOptions<SetApartmentVariablesResponse, SetApartmentVariablesError, Options<SetApartmentVariablesData>> => {
    const mutationOptions: UseMutationOptions<SetApartmentVariablesResponse, SetApartmentVariablesError, Options<SetApartmentVariablesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setApartmentVariables({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApartmentVariableMatrixQueryKey = (options?: Options<GetApartmentVariableMatrixData>) => createQueryKey('getApartmentVariableMatrix', options);

/**
 * Данные квартир матрицей «квартиры × названия»
 *
 * ⚠️ ОТДАЁТ МАТРИЦУ, А НЕ ПЛОСКИЙ СПИСОК КЛЮЧЕЙ, и это несущее решение раздела. §2.10 называет ответ прямым текстом: «матричный вид (квартиры × данные) с видимыми пробелами — самое полезное, что здесь может сделать интерфейс». Полезен он потому, что названия общие для компании ЛИШЬ НЕЯВНО: название существует, пока хотя бы у одной квартиры есть по нему значение. Значит опечатка («этаж» против «Этаж») заводит отдельное данное у одной квартиры и молча ломает вставку у всех остальных — увидеть это можно ТОЛЬКО рядом, в одной таблице.
 *
 * Собрать матрицу на клиенте нельзя: значения лежат в карточке квартиры (GET /apartments/{id}), то есть таблица стоила бы по запросу на каждую квартиру. Ключи при этом отдельной ручкой больше не нужны — это `keys` этого же ответа, и второй способ их узнать однажды разошёлся бы с первым.
 */
export const getApartmentVariableMatrixOptions = (options?: Options<GetApartmentVariableMatrixData>) => queryOptions<GetApartmentVariableMatrixResponse, GetApartmentVariableMatrixError, GetApartmentVariableMatrixResponse, ReturnType<typeof getApartmentVariableMatrixQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApartmentVariableMatrix({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApartmentVariableMatrixQueryKey(options)
});

/**
 * Удалить переменную у всех квартир компании
 *
 * РАЗРУШИТЕЛЬНАЯ операция на всю компанию. Снимает значение ключа у всех квартир за один вызов; после неё ключ исчезает и из GET /apartment-variables, и из палитры токенов GET /content/tokens — ровно по семантике distinct-списка (ключ существует, пока хотя бы у одной квартиры есть значение).
 *
 * Зачем она нужна. Ключи заводятся неявно — записью значения, в том числе импортом таблицы. Значит опечатка в заголовке колонки («парковкa» с латинской «a») заводит мусорный ключ, который иначе торчал бы на экране КАЖДОЙ квартиры (мы показываем объединение всех ключей компании) и в палитре токенов. Навсегда. Это ручка «исправить опечатку в импорте».
 *
 * ВНИМАНИЕ, гостевые последствия. Если на `{{apartment.<key>}}` ссылается хотя бы одна инструкция, после удаления гость увидит в ней `[[unresolved:apartment.<key>]]` вместо текста. Фронт ОБЯЗАН предупредить об этом в диалоге подтверждения и назвать радиус поражения числом — сколько квартир потеряют значение. Молча выполнять нельзя: связь между «менеджер убрал опечатку» и «у гостя сломалась инструкция» никто потом не установит.
 *
 * Бекенд-примитив: DeleteApartmentVariableKey(key), компания берётся из сессии.
 */
export const deleteApartmentVariableKeyMutation = (options?: Partial<Options<DeleteApartmentVariableKeyData>>): UseMutationOptions<DeleteApartmentVariableKeyResponse, DeleteApartmentVariableKeyError, Options<DeleteApartmentVariableKeyData>> => {
    const mutationOptions: UseMutationOptions<DeleteApartmentVariableKeyResponse, DeleteApartmentVariableKeyError, Options<DeleteApartmentVariableKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApartmentVariableKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Заполнить одно данное сразу у нескольких квартир
 *
 * Пишет ОДНО название сразу многим квартирам — то, что человек делает в виде «Заполнение»: столбец «код домофона» заполняется по всем объектам за один заход.
 *
 * ⚠️ Почему это отдельная ручка, а не N вызовов PATCH /apartments/{id}/variables. Записать столбец поквартирно можно, но тогда обрыв связи на середине оставляет ПОЛОВИНУ столбца записанной, и сказать менеджеру, какие строки доехали, клиенту нечем — он видит одну общую ошибку. Здесь ответ один, и он же говорит, сколько квартир изменилось. Это тот же довод, по которому матрица читается одним запросом, а не по запросу на квартиру (см. GET выше).
 *
 * Семантика значения — ровно как у поквартирной записи: строка это значение, пустая строка это ЗНАЧЕНИЕ «пусто», а `null` стирает данное у этой квартиры. Квартиры, которых нет в `values`, не трогаются вовсе — заполнение одного столбца не должно задевать соседние.
 *
 * Ключ, которого у компании ещё нет, эта же операция и заводит — неявно, как и поквартирная запись (см. банер над ApartmentVariableEntry): отдельной ручки «создать название» нет, и попап «Новое данное» в интерфейсе — это просто заполнение нового ключа.
 */
export const fillApartmentVariableMutation = (options?: Partial<Options<FillApartmentVariableData>>): UseMutationOptions<FillApartmentVariableResponse, FillApartmentVariableError, Options<FillApartmentVariableData>> => {
    const mutationOptions: UseMutationOptions<FillApartmentVariableResponse, FillApartmentVariableError, Options<FillApartmentVariableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fillApartmentVariable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Импорт значений переменных квартир из таблицы
 *
 * Массовая заливка матрицы «квартира × переменные» одним файлом — быстрее, чем вызывать setApartmentVariables по каждой квартире отдельно. Формат и разбор файла — на сервере. Новую колонку таблицы импорт заводит как новый ключ автоматически — так же неявно, как и setApartmentVariables (см. банер над ApartmentVariableEntry в components/schemas/apartment.yaml); список таких новых ключей считает импортёр (gateway), см. ApartmentVariablesImportSummary.newKeys. Построчные ошибки (например, квартира не найдена) не блокируют остальной файл: они попадают в errors сводки, а корректные строки применяются — но это только для проблем внутри читаемого файла, см. 400 ниже.
 */
export const importApartmentVariablesMutation = (options?: Partial<Options<ImportApartmentVariablesData>>): UseMutationOptions<ImportApartmentVariablesResponse, ImportApartmentVariablesError, Options<ImportApartmentVariablesData>> => {
    const mutationOptions: UseMutationOptions<ImportApartmentVariablesResponse, ImportApartmentVariablesError, Options<ImportApartmentVariablesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importApartmentVariables({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listClientsQueryKey = (options?: Options<ListClientsData>) => createQueryKey('listClients', options);

/**
 * База гостей компании
 *
 * Гости, у которых есть живая связь с моей компанией (§2.1). Сортировка — по последнему подтверждению связи, DESC.
 * **Два независимых фильтра, комбинируются.** `name` — подстрока по ЛЮБОМУ варианту написания: «Наталья» найдёт гостя, который отображается как «Natalia Dabizha», если оба варианта записаны; регистр и пунктуация не важны («петров и в» находит «Петров И.В.»).
 * ⚠️ `phone` — ТОЛЬКО ТОЧНОЕ СОВПАДЕНИЕ ЦЕЛИКОМ. Половина номера не найдёт ничего, и придёт пустой список БЕЗ ошибки — телефоны в базе зашифрованы, поиск по подстроке технически невозможен (§4). Интерфейс обязан сказать это ДО поиска, иначе менеджер решит, что база пуста.
 */
export const listClientsOptions = (options?: Options<ListClientsData>) => queryOptions<ListClientsResponse, ListClientsError, ListClientsResponse, ReturnType<typeof listClientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listClients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listClientsQueryKey(options)
});

export const listClientsInfiniteQueryKey = (options?: Options<ListClientsData>): QueryKey<Options<ListClientsData>> => createQueryKey('listClients', options, true);

/**
 * База гостей компании
 *
 * Гости, у которых есть живая связь с моей компанией (§2.1). Сортировка — по последнему подтверждению связи, DESC.
 * **Два независимых фильтра, комбинируются.** `name` — подстрока по ЛЮБОМУ варианту написания: «Наталья» найдёт гостя, который отображается как «Natalia Dabizha», если оба варианта записаны; регистр и пунктуация не важны («петров и в» находит «Петров И.В.»).
 * ⚠️ `phone` — ТОЛЬКО ТОЧНОЕ СОВПАДЕНИЕ ЦЕЛИКОМ. Половина номера не найдёт ничего, и придёт пустой список БЕЗ ошибки — телефоны в базе зашифрованы, поиск по подстроке технически невозможен (§4). Интерфейс обязан сказать это ДО поиска, иначе менеджер решит, что база пуста.
 */
export const listClientsInfiniteOptions = (options?: Options<ListClientsData>) => {
    const opts = infiniteQueryOptions<ListClientsResponse, ListClientsError, InfiniteData<ListClientsResponse>, QueryKey<Options<ListClientsData>>, Cursor | Pick<QueryKey<Options<ListClientsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListClientsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listClients({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listClientsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getClientCatalogQueryKey = (options?: Options<GetClientCatalogData>) => createQueryKey('getClientCatalog', options);

/**
 * Справочник для форм гостя
 *
 * Только то, где интерфейс ПРЕДЛАГАЕТ выбор (виды каналов в форме добавления). Для показа каталог не нужен — подписи приходят рядом со значениями.
 */
export const getClientCatalogOptions = (options?: Options<GetClientCatalogData>) => queryOptions<GetClientCatalogResponse, GetClientCatalogError, GetClientCatalogResponse, ReturnType<typeof getClientCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getClientCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getClientCatalogQueryKey(options)
});

export const getClientsSummaryQueryKey = (options?: Options<GetClientsSummaryData>) => createQueryKey('getClientsSummary', options);

/**
 * Сводка по базе гостей
 *
 * Весь экран сводки ОДНИМ запросом: все пять агрегатов считаются по одной и той же базе, и отдельных ручек под блоки нет и не нужно.
 * Параметров нет намеренно. Компания берётся из сессии — поля `companyId` в запросе нет, чтобы сводку по чужой базе нельзя было даже попросить — то же правило, что у остальных ручек гостей. ⚠️ Оно НЕСУЩЕЕ, а не стилевое: `companyId` и `actorUserId` в запросе сделали бы возможным действие от имени чужой компании: clients-service не проверяет права и доверяет присланному, а ставит их шлюз из сессии. (Спеки гостевого раздела удалены как неактуальные — правило живёт здесь и в тестах.) Фильтров по датам тоже нет: окна фиксированы (7/30/90 дней).
 * Пустая база — НЕ ошибка: придёт `200` с нулями, пустыми массивами и без `firstGuestAt` / `lastActivityAt`. Отдельного кода ответа под «нет данных» не будет.
 */
export const getClientsSummaryOptions = (options?: Options<GetClientsSummaryData>) => queryOptions<GetClientsSummaryResponse, GetClientsSummaryError, GetClientsSummaryResponse, ReturnType<typeof getClientsSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getClientsSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getClientsSummaryQueryKey(options)
});

export const getClientQueryKey = (options: Options<GetClientData>) => createQueryKey('getClient', options);

/**
 * Карточка гостя
 *
 * Одна карточка на два экрана — в брони и в разделе «Гости». Прежняя узкая ручка карточки (`GetClientCard` у гейтвея) не несла ни атрибуции, ни вариантов имени, ни компаний; здесь полная форма, гейтвей маппит её на `ClientsService.GetClient` (§3).
 * `stats` и `history` — склейка с bookings-service и потому необязательны: clients-service броней не знает (§1).
 */
export const getClientOptions = (options: Options<GetClientData>) => queryOptions<GetClientResponse, GetClientError, GetClientResponse, ReturnType<typeof getClientQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getClient({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getClientQueryKey(options)
});

/**
 * Убрать гостя из базы компании
 *
 * ⚠️ ЭТО НЕ УДАЛЕНИЕ ГОСТЯ. Снимается связь с моей компанией: гость пропадает из моего списка, но остаётся в базах других компаний, и если снова забронирует у меня — вернётся автоматически (§5). Формулировка в интерфейсе — «Убрать из базы», не «Удалить гостя».
 */
export const unlinkClientMutation = (options?: Partial<Options<UnlinkClientData>>): UseMutationOptions<UnlinkClientResponse, UnlinkClientError, Options<UnlinkClientData>> => {
    const mutationOptions: UseMutationOptions<UnlinkClientResponse, UnlinkClientError, Options<UnlinkClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unlinkClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Добавить каналы связи
 *
 * Батчевая: тело — массив (§5). Ответ 200 даже при отказе по отдельным каналам — результат читается построчно, см. ClientContactsAddResult.
 */
export const addClientContactsMutation = (options?: Partial<Options<AddClientContactsData>>): UseMutationOptions<AddClientContactsResponse, AddClientContactsError, Options<AddClientContactsData>> => {
    const mutationOptions: UseMutationOptions<AddClientContactsResponse, AddClientContactsError, Options<AddClientContactsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addClientContacts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Убрать канал из данных компании
 *
 * Снимает претензию МОЕЙ компании. Канал остаётся в карточке, если его заявляет кто-то ещё — об этом говорит `channelRetired: false`, и строку в этом случае убирать НЕЛЬЗЯ (§5).
 */
export const removeClientContactMutation = (options?: Partial<Options<RemoveClientContactData>>): UseMutationOptions<RemoveClientContactResponse, RemoveClientContactError, Options<RemoveClientContactData>> => {
    const mutationOptions: UseMutationOptions<RemoveClientContactResponse, RemoveClientContactError, Options<RemoveClientContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeClientContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Изменить метку канала
 *
 * Метка — ЕДИНСТВЕННОЕ, что у канала правится. Значения канала операции правки нет и не будет (§2.5): неправильный номер удаляют и добавляют правильный.
 * Только свой канал. Чужой вернёт 422 — но до этого доходить не должно, кнопка обязана быть неактивной по `ClientContact.editable` (§10).
 */
export const updateClientContactLabelMutation = (options?: Partial<Options<UpdateClientContactLabelData>>): UseMutationOptions<UpdateClientContactLabelResponse, UpdateClientContactLabelError, Options<UpdateClientContactLabelData>> => {
    const mutationOptions: UseMutationOptions<UpdateClientContactLabelResponse, UpdateClientContactLabelError, Options<UpdateClientContactLabelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateClientContactLabel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Добавить вариант имени
 *
 * Имя не заменяется, а ДОПОЛНЯЕТСЯ (§2.4). Удаления варианта нет вовсе (§11) — ошиблись, добавьте правильный и сделайте основным.
 */
export const addClientNameMutation = (options?: Partial<Options<AddClientNameData>>): UseMutationOptions<AddClientNameResponse, AddClientNameError, Options<AddClientNameData>> => {
    const mutationOptions: UseMutationOptions<AddClientNameResponse, AddClientNameError, Options<AddClientNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addClientName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Сделать вариант имени основным
 *
 * Основной вариант виден в списках и на кнопках — он же уезжает в шапку карточки.
 */
export const setClientDisplayNameMutation = (options?: Partial<Options<SetClientDisplayNameData>>): UseMutationOptions<SetClientDisplayNameResponse, SetClientDisplayNameError, Options<SetClientDisplayNameData>> => {
    const mutationOptions: UseMutationOptions<SetClientDisplayNameResponse, SetClientDisplayNameError, Options<SetClientDisplayNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setClientDisplayName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Загрузить файл базы гостей (фаза 1 — отчёт)
 *
 * Разбирает `.xlsx` и отвечает ОТЧЁТОМ. ⚠️ НИЧЕГО НЕ ЗАПИСЫВАЕТ: гости появятся только после `commitClientImport`. Колонки сервер определяет по заголовку, порядок не важен (имя — «Имя»/«ФИО»/«Гость»/«Клиент»/«Name», телефон — «Телефон»/«Тел»/«Номер»/«Phone», почта — «Почта»/«Email»/«E-mail»); прочие колонки сохраняются справочно и в данные гостя не превращаются. Разбор целиком на сервере — своего парсера у фронта нет и быть не должно.
 */
export const uploadClientImportMutation = (options?: Partial<Options<UploadClientImportData>>): UseMutationOptions<UploadClientImportResponse, UploadClientImportError, Options<UploadClientImportData>> => {
    const mutationOptions: UseMutationOptions<UploadClientImportResponse, UploadClientImportError, Options<UploadClientImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadClientImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getClientImportQueryKey = (options: Options<GetClientImportData>) => createQueryKey('getClientImport', options);

/**
 * Состояние загрузки
 *
 * Тот же отчёт, перечитанный. ⚠️ Ради ЭТОЙ ручки существует опрос: commit возвращается сразу, и ход применения виден только здесь — счётчики rowsCreated/rowsMatched сервер обновляет раз в 200 строк. Пока статус committing — применение идёт.
 */
export const getClientImportOptions = (options: Options<GetClientImportData>) => queryOptions<GetClientImportResponse, GetClientImportError, GetClientImportResponse, ReturnType<typeof getClientImportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getClientImport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getClientImportQueryKey(options)
});

/**
 * Применить загрузку (фаза 2 — запись)
 *
 * Заводит гостей по строкам, прошедшим отбор. Дедупликация по телефону: строка на существующего гостя не создаёт второго, а пополняет его карточку (имя копится вариантом, §2.4), поэтому повторная загрузка того же файла безопасна. ⚠️ ВОЗВРАЩАЕТСЯ СРАЗУ, ПРИМЕНЯЕТ ФОНОМ. Захват пачки синхронный, дальше применение уходит в фоновую задачу, и соединения вызов не держит (`prima-clients`, `internal/transport/grpc/import_server.go`, `CommitImport`). Само применение долгое — их замер даёт 14 610 строк за 3 мин 54 с, потолок фоновой задачи 30 минут. Отсюда два следствия: увеличенный таймаут ИМЕННО НА ЭТУ РУЧКУ гейтвею НЕ нужен, она отвечает сразу; а интерфейс НЕ ДОЛЖЕН запирать менеджера модалкой «подождите» — он ведёт применение опросом getClientImport, а не ответом этого вызова.
 */
export const commitClientImportMutation = (options?: Partial<Options<CommitClientImportData>>): UseMutationOptions<CommitClientImportResponse, CommitClientImportError, Options<CommitClientImportData>> => {
    const mutationOptions: UseMutationOptions<CommitClientImportResponse, CommitClientImportError, Options<CommitClientImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commitClientImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отменить загрузку
 *
 * Отказ от разобранного файла. Отменять по существу нечего — записи ещё не было, — но загрузка закрывается явно, и повторный commit по ней уже не пройдёт. Отвечает самой загрузкой, чтобы экран показал закрытое состояние, а не догадывался о нём по отсутствию ответа.
 */
export const cancelClientImportMutation = (options?: Partial<Options<CancelClientImportData>>): UseMutationOptions<CancelClientImportResponse, CancelClientImportError, Options<CancelClientImportData>> => {
    const mutationOptions: UseMutationOptions<CancelClientImportResponse, CancelClientImportError, Options<CancelClientImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelClientImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listClientImportRowsQueryKey = (options: Options<ListClientImportRowsData>) => createQueryKey('listClientImportRows', options);

/**
 * Строки загрузки
 *
 * Разбор проблемных строк: номер в файле, что стояло в ячейках и почему строка не прошла. Это рабочий инструмент, а не диагностика: менеджер по нему правит свой файл и заливает заново.
 */
export const listClientImportRowsOptions = (options: Options<ListClientImportRowsData>) => queryOptions<ListClientImportRowsResponse, ListClientImportRowsError, ListClientImportRowsResponse, ReturnType<typeof listClientImportRowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listClientImportRows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listClientImportRowsQueryKey(options)
});

export const listClientImportRowsInfiniteQueryKey = (options: Options<ListClientImportRowsData>): QueryKey<Options<ListClientImportRowsData>> => createQueryKey('listClientImportRows', options, true);

/**
 * Строки загрузки
 *
 * Разбор проблемных строк: номер в файле, что стояло в ячейках и почему строка не прошла. Это рабочий инструмент, а не диагностика: менеджер по нему правит свой файл и заливает заново.
 */
export const listClientImportRowsInfiniteOptions = (options: Options<ListClientImportRowsData>) => {
    const opts = infiniteQueryOptions<ListClientImportRowsResponse, ListClientImportRowsError, InfiniteData<ListClientImportRowsResponse>, QueryKey<Options<ListClientImportRowsData>>, number | Pick<QueryKey<Options<ListClientImportRowsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListClientImportRowsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listClientImportRows({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listClientImportRowsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listChannelsQueryKey = (options?: Options<ListChannelsData>) => createQueryKey('listChannels', options);

/**
 * Каналы компании
 *
 * Все каналы компании одним списком — аккаунты и боты одной моделью (Channel): подключённые и незавершённые подключения (`status: pending`).
 */
export const listChannelsOptions = (options?: Options<ListChannelsData>) => queryOptions<ListChannelsResponse, ListChannelsError, ListChannelsResponse, ReturnType<typeof listChannelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChannels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChannelsQueryKey(options)
});

export const getChannelLimitsQueryKey = (options?: Options<GetChannelLimitsData>) => createQueryKey('getChannelLimits', options);

/**
 * Бюджет канала — пределы, о которые текст спотыкается у гостя
 *
 * Источник — prima-inbox (`GetChannelLimits`): публикует их тот, кто применяет.
 * ⚠️ НЕ КЛАСТЬ ЭТИ ЧИСЛА ОБРАТНО В КАТАЛОГ АВТОРИНГА КОНТЕНТА. Они там жили и переехали сюда целиком: предел принадлежит каналу и установке, а копия в другом сервисе разойдётся молча (ответ бекенда 21.08, §2).
 * ⚠️ Параметра канала у ручки НЕТ, и это решение, а не упущение. Числа у каналов разные, но автор пишет ОДИН текст на все каналы сразу, и полезный ему ответ — САМЫЙ СТРОГИЙ из них (так же собраны числа в спеке, 4.5). Параметр потребовал бы от редактора выбрать канал там, где выбора нет. От текста ответ не зависит вовсе.
 */
export const getChannelLimitsOptions = (options?: Options<GetChannelLimitsData>) => queryOptions<GetChannelLimitsResponse, GetChannelLimitsError, GetChannelLimitsResponse, ReturnType<typeof getChannelLimitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChannelLimits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChannelLimitsQueryKey(options)
});

export const getChannelCatalogQueryKey = (options?: Options<GetChannelCatalogData>) => createQueryKey('getChannelCatalog', options);

/**
 * Каталог типов канала
 *
 * Витрина «Подключить канал» строится из этого списка, а не из хардкода фронта (тот же приём, что и каталог движка сценариев, см. getScenarioCatalog) — новый тип канала появляется здесь без деплоя фронта. Каталог отдаёт только типы, которые в ЭТОЙ установке можно подключить: тип, у которого prima-connect отвечает `available = false` (адаптер не настроен — WhatsApp, например, в установке необязателен) или `connect_method = none` (SMS-провайдер), в список не входит. По каталогу же строятся и фильтры типов на экране.
 */
export const getChannelCatalogOptions = (options?: Options<GetChannelCatalogData>) => queryOptions<GetChannelCatalogResponse, GetChannelCatalogError, GetChannelCatalogResponse, ReturnType<typeof getChannelCatalogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChannelCatalog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChannelCatalogQueryKey(options)
});

export const listChannelEventsQueryKey = (options?: Options<ListChannelEventsData>) => createQueryKey('listChannelEvents', options);

/**
 * История событий по каналам
 *
 * Одна лента на всю компанию, не по одному каналу — какого канала касается запись, видно из текста события (ChannelEvent.text), например «MAX · Приём броней → нужен повторный вход».
 */
export const listChannelEventsOptions = (options?: Options<ListChannelEventsData>) => queryOptions<ListChannelEventsResponse, ListChannelEventsError, ListChannelEventsResponse, ReturnType<typeof listChannelEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChannelEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChannelEventsQueryKey(options)
});

export const listChannelEventsInfiniteQueryKey = (options?: Options<ListChannelEventsData>): QueryKey<Options<ListChannelEventsData>> => createQueryKey('listChannelEvents', options, true);

/**
 * История событий по каналам
 *
 * Одна лента на всю компанию, не по одному каналу — какого канала касается запись, видно из текста события (ChannelEvent.text), например «MAX · Приём броней → нужен повторный вход».
 */
export const listChannelEventsInfiniteOptions = (options?: Options<ListChannelEventsData>) => {
    const opts = infiniteQueryOptions<ListChannelEventsResponse, ListChannelEventsError, InfiniteData<ListChannelEventsResponse>, QueryKey<Options<ListChannelEventsData>>, Cursor | Pick<QueryKey<Options<ListChannelEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListChannelEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listChannelEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listChannelEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getChannelCascadeQueryKey = (options?: Options<GetChannelCascadeData>) => createQueryKey('getChannelCascade', options);

/**
 * Каскад эскалации каналов
 *
 * Каскад компании по умолчанию — приоритетный порядок мессенджеров, в котором система пробует достучаться до гостя, пока он не ответил (пробуем первый, при неудаче — следующий; порядок элементов массива значим). Первый ответ гостя фиксирует мессенджер дальнейшего общения. Блок `reach` («Первый контакт») в сценарии может переопределить этот порядок для себя: его поле `config.channels` (BlockField с `kind: orderedChannels`) заменяет каскад компании на время этого шага; если свой каскад блок не задал, применяется каскад компании — тот, что возвращает эта ручка (см. также `saveChannelCascade`). Пул мессенджеров фиксирован (`max`/`telegram`/`vk`/`whatsapp`/`sms`). Какой именно подключённый канал (Channel) отвечает на попытку по мессенджеру — решает флаг `Channel.forGuests`, этот список только про порядок мессенджеров.
 */
export const getChannelCascadeOptions = (options?: Options<GetChannelCascadeData>) => queryOptions<GetChannelCascadeResponse, GetChannelCascadeError, GetChannelCascadeResponse, ReturnType<typeof getChannelCascadeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChannelCascade({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChannelCascadeQueryKey(options)
});

/**
 * Сохранить каскад эскалации каналов
 *
 * Полная замена каскада компании по умолчанию — семантика та же, что у `getChannelCascade` (см. его description про связь с полем `config.channels` блока `reach`).
 */
export const saveChannelCascadeMutation = (options?: Partial<Options<SaveChannelCascadeData>>): UseMutationOptions<SaveChannelCascadeResponse, SaveChannelCascadeError, Options<SaveChannelCascadeData>> => {
    const mutationOptions: UseMutationOptions<SaveChannelCascadeResponse, SaveChannelCascadeError, Options<SaveChannelCascadeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveChannelCascade({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBotLinksQueryKey = (options?: Options<ListBotLinksData>) => createQueryKey('listBotLinks', options);

/**
 * Боты компании и ссылки на них
 *
 * По каждому мессенджеру: публичное имя бота, готовая ссылка и состояние (3.5). Нужно, чтобы менеджер мог открыть СВОЕГО бота и убедиться, что тот отвечает.
 *
 * ⚠️ Состояний ТРИ, и третье не сводится ко второму: `unknown` — «узнать не удалось». Временный сбой, показанный как «не подключён», отправит менеджера переподключать работающего бота.
 *
 * ⚠️ Ссылка здесь ОБЫЧНАЯ, без кода брони. Персональная ссылка гостя одноразовая и привязывает к брони тот чат, который её открыл; для гостя есть отдельная ручка переотправки.
 */
export const listBotLinksOptions = (options?: Options<ListBotLinksData>) => queryOptions<ListBotLinksResponse, ListBotLinksError, ListBotLinksResponse, ReturnType<typeof listBotLinksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBotLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBotLinksQueryKey(options)
});

/**
 * Начать подключение по QR
 *
 * Заводит асинхронную сессию подключения и возвращает QR-код (qrSvg) для сканирования в приложении мессенджера. Состояние — отдельным поллингом через getQrConnect по linkId. Годится только для типов с connect: qr в каталоге (ChannelType.connect) — для connect: token используется connectByToken.
 *
 * Канал заводится сразу, в статусе `pending`, и виден в списке, пока вход не завершён. Бросить подключение — `cancelQrConnect`: иначе незавершённый канал так и останется в списке.
 */
export const startQrConnectMutation = (options?: Partial<Options<StartQrConnectData>>): UseMutationOptions<StartQrConnectResponse, StartQrConnectError, Options<StartQrConnectData>> => {
    const mutationOptions: UseMutationOptions<StartQrConnectResponse, StartQrConnectError, Options<StartQrConnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startQrConnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отменить привязку
 *
 * Менеджер бросил подключение — «Отменить привязку» или закрыл окно, пока вход не пошёл: до сканирования, на шаге пароля, после провала или истечения кода.
 *
 * ⚠️ РЕШАЕТ ЖИВОЙ ШАГ СЕССИИ, а не её история: шлюз читает `GetOnboarding` перед удалением. Вход идёт или прошёл (`step = scanned` или `status = completed`) — 409 `LinkScanned`, и ничего не трогается: вход доводится до конца, а ненужный канал удаляют `deleteChannel` — тот отвязывает аккаунт как положено. Почему не удалять: удаление незавершённого канала НЕ останавливает попытку у адаптера (глагола отмены у prima-connect нет), и вход, довершившийся после удаления, оставит у адаптера живой аккаунт без канала — у WhatsApp связанное устройство и зеркало переписки, которые из Prima не отвязать, а номер больше не подключить («уже подключён»); у MAX — ту же вошедшую сессию без владельца. Ждём сканирования, ждём пароль (`awaiting_password` — вход ещё не случился), `expired`, `failed` (в том числе после скана) — 204, и подключение (новое или продолжение незавершённого) уносит свой канал. Живой шаг не прочитан (адаптер недоступен) — 503, ничего не тронуто.
 *
 * Окно не зовёт отмену, пока вход идёт («входим»), и пока летит `submitQrPassword` — решает по вердикту. 409 — гонка: код отсканировали между опросом и отменой. Сузить её дёшево: у WhatsApp шлюз перед живым чтением выжидает несколько секунд (скан в пути доходит до адаптера не сразу), — окно ответа не ждёт. Пока по этому linkId у шлюза летит `submitQrPassword`, отмена ждёт его вердикта: принят — 409 `LinkScanned`, иначе — по живому шагу.
 *
 * Перепривязка подключённого канала (relinkChannel у канала не в pending) — канал остаётся как был, а сессия истечёт сама. Что это за сессия, шлюз знает по linkId (ChannelLink.linkId).
 *
 * Право — то же, что на начало сессии (startQrConnect). Удалить без права удалять каналы оно позволяет только незавершённый канал этой сессии — по linkId, который выдал шлюз.
 *
 * Идемпотентна: повтор и отмена уже завершённой отменой или неизвестной сессии — тоже 204. Окно зовёт её, не дожидаясь ответа, — ему нечего показать, кроме того, что оно закрыто.
 */
export const cancelQrConnectMutation = (options?: Partial<Options<CancelQrConnectData>>): UseMutationOptions<CancelQrConnectResponse, CancelQrConnectError, Options<CancelQrConnectData>> => {
    const mutationOptions: UseMutationOptions<CancelQrConnectResponse, CancelQrConnectError, Options<CancelQrConnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelQrConnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getQrConnectQueryKey = (options: Options<GetQrConnectData>) => createQueryKey('getQrConnect', options);

/**
 * Состояние QR-подключения
 *
 * Фронт поллит эту ручку раз в pollIntervalMs, пока state не станет connected, expired или failed. 404 — канала этой сессии нет в активной компании: его удалили или компанию в сессии сменили. Протухший код — не 404: сессия и её linkId живут, пока жив канал, и истёкшая отвечает 200 с state: expired сколь угодно долго.
 *
 * ⚠️ 503 — адаптер мессенджера сейчас не отвечает (шаг сессии читается у него вживую): это не конец подключения. Окно оставляет текущий экран и спрашивает снова на следующем тике.
 */
export const getQrConnectOptions = (options: Options<GetQrConnectData>) => queryOptions<GetQrConnectResponse, GetQrConnectError, GetQrConnectResponse, ReturnType<typeof getQrConnectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQrConnect({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQrConnectQueryKey(options)
});

/**
 * Перевыпустить QR-код
 *
 * Новый код для той же сессии linkId — после state: expired («показать новый код») или failed («начать заново»); state возвращается в waiting. Канал новый не заводится: сессия перевыпускает код для того же незавершённого канала.
 */
export const refreshQrConnectMutation = (options?: Partial<Options<RefreshQrConnectData>>): UseMutationOptions<RefreshQrConnectResponse, RefreshQrConnectError, Options<RefreshQrConnectData>> => {
    const mutationOptions: UseMutationOptions<RefreshQrConnectResponse, RefreshQrConnectError, Options<RefreshQrConnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshQrConnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Отправить пароль аккаунта
 *
 * Ответ на state: password — у аккаунта мессенджера есть пароль входа (двухэтапная проверка), и одного сканирования мало. 204 — пароль принят: опрос продолжается, state станет scanned, затем connected.
 *
 * ⚠️ ПОКА ЗАПРОС ЛЕТИТ, ОТВЕТЫ ОПРОСА НЕ РИСОВАТЬ: опрос, обогнавший вердикт, ещё читает password, и форма мелькнула бы снова. Ответ может идти до ~30 секунд — сервер ждёт вердикта мессенджера.
 *
 * ⚠️ ПАРОЛЬ — ЧУЖОЙ СЕКРЕТ. Уходит в мессенджер как есть (пробелы — его часть, не обрезать), сервер его не хранит и не пишет в журналы; клиенту — не класть в кеш и не отдавать менеджеру паролей браузера.
 */
export const submitQrPasswordMutation = (options?: Partial<Options<SubmitQrPasswordData>>): UseMutationOptions<SubmitQrPasswordResponse, SubmitQrPasswordError, Options<SubmitQrPasswordData>> => {
    const mutationOptions: UseMutationOptions<SubmitQrPasswordResponse, SubmitQrPasswordError, Options<SubmitQrPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitQrPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Подключить канал по токену
 *
 * Синхронное подключение: сервер сразу проверяет токен у провайдера и в одном ответе либо подключает канал (201), либо отвечает одной из четырёх ошибок. Годится только для типов с connect: token в каталоге (ChannelType.connect) — для connect: qr используется startQrConnect. `400 https://prima.ru/errors/channel-invalid-token` — «Токен неверный». `403 https://prima.ru/errors/channel-token-scope` — «У токена нет нужного доступа». `409 https://prima.ru/errors/channel-already-connected` — «Канал такого типа уже подключён»: возникает только у типов с `multiple: false` (боты — один канал на компанию). `503 https://prima.ru/errors/channel-provider-unavailable` — «Канал временно недоступен»: не ошибка запроса, провайдер мессенджера не отвечает, стоит повторить попытку позже.
 */
export const connectByTokenMutation = (options?: Partial<Options<ConnectByTokenData>>): UseMutationOptions<ConnectByTokenResponse, ConnectByTokenError, Options<ConnectByTokenData>> => {
    const mutationOptions: UseMutationOptions<ConnectByTokenResponse, ConnectByTokenError, Options<ConnectByTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await connectByToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Удалить канал
 *
 * Отключает и удаляет канал целиком. Отменить нельзя — для временной остановки есть disableChannel (у каналов, где он есть в `Channel.actions`). Аккаунт WhatsApp prima-connect при этом отвязывает и НЕОБРАТИМО стирает переписку, которую хранит адаптер; что сказать в подтверждении, сервер кладёт в `ChannelAction.warning` действия `remove`.
 */
export const deleteChannelMutation = (options?: Partial<Options<DeleteChannelData>>): UseMutationOptions<DeleteChannelResponse, DeleteChannelError, Options<DeleteChannelData>> => {
    const mutationOptions: UseMutationOptions<DeleteChannelResponse, DeleteChannelError, Options<DeleteChannelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteChannel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Изменить канал
 *
 * Оба поля тела необязательны — сервер меняет только переданные, пустое тело — 400. name — внутреннее имя (Channel.name): сервер обрезает пробелы по краям, пустая строка снимает имя, и канал снова зовётся именем по умолчанию. forGuests переключает участие в общении с гостями (см. Channel.forGuests) — не влияет на status.
 */
export const updateChannelMutation = (options?: Partial<Options<UpdateChannelData>>): UseMutationOptions<UpdateChannelResponse, UpdateChannelError, Options<UpdateChannelData>> => {
    const mutationOptions: UseMutationOptions<UpdateChannelResponse, UpdateChannelError, Options<UpdateChannelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChannel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Перепривязать канал
 *
 * Перепривязка QR-канала. Доступна не только реактивно, для статуса needs_relogin (см. Channel.actions) — менеджер может перепривязать и уже активный, здоровый MAX-канал проактивно, не дожидаясь разрыва сессии. Та же QR-сессия, что и startQrConnect, но заведённая для уже существующего channelId, а не для нового канала: после сканирования QR канал обновляется на месте, а не создаётся заново. Состояние — тем же поллингом getQrConnect по linkId из ответа; пароль, если аккаунт им защищён, — тем же submitQrPassword. У канала в pending (подключение не завершено) это продолжение подключения: новый код для того же канала. У WhatsApp повторного входа нет (prima-connect: supports_relogin = false) — только продолжение незавершённого; действия relink у подключённого WhatsApp сервер не отдаёт.
 */
export const relinkChannelMutation = (options?: Partial<Options<RelinkChannelData>>): UseMutationOptions<RelinkChannelResponse, RelinkChannelError, Options<RelinkChannelData>> => {
    const mutationOptions: UseMutationOptions<RelinkChannelResponse, RelinkChannelError, Options<RelinkChannelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await relinkChannel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Сменить токен канала
 *
 * Синхронная замена токена уже подключённого канала (бота) — сервер проверяет новый токен у провайдера и либо сохраняет его (200), либо отвечает одной из тех же ошибок, что и connectByToken. `400 https://prima.ru/errors/channel-invalid-token` — «Токен неверный». `403 https://prima.ru/errors/channel-token-scope` — «У токена нет нужного доступа». `503 https://prima.ru/errors/channel-provider-unavailable` — «Канал временно недоступен», стоит повторить попытку позже.
 */
export const changeChannelTokenMutation = (options?: Partial<Options<ChangeChannelTokenData>>): UseMutationOptions<ChangeChannelTokenResponse, ChangeChannelTokenError, Options<ChangeChannelTokenData>> => {
    const mutationOptions: UseMutationOptions<ChangeChannelTokenResponse, ChangeChannelTokenError, Options<ChangeChannelTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeChannelToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Включить канал
 *
 * Снимает статус disabled («приостановлен вручную») — канал возвращается к работе.
 */
export const enableChannelMutation = (options?: Partial<Options<EnableChannelData>>): UseMutationOptions<EnableChannelResponse, EnableChannelError, Options<EnableChannelData>> => {
    const mutationOptions: UseMutationOptions<EnableChannelResponse, EnableChannelError, Options<EnableChannelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableChannel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Приостановить канал
 *
 * Переводит канал в status: disabled вручную — канал остаётся подключённым, просто не используется, пока его не включат обратно (enableChannel).
 */
export const disableChannelMutation = (options?: Partial<Options<DisableChannelData>>): UseMutationOptions<DisableChannelResponse, DisableChannelError, Options<DisableChannelData>> => {
    const mutationOptions: UseMutationOptions<DisableChannelResponse, DisableChannelError, Options<DisableChannelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disableChannel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPaymentSettingsQueryKey = (options?: Options<GetPaymentSettingsData>) => createQueryKey('getPaymentSettings', options);

/**
 * Настройки платежей
 *
 * Только настройки — провайдеры, реквизиты, залог. Сами платежи по бронированиям исполняет движок сценариев (см. paths/scenarios.yaml), отдельной ручки приёма платежа в этом контракте нет.
 */
export const getPaymentSettingsOptions = (options?: Options<GetPaymentSettingsData>) => queryOptions<GetPaymentSettingsResponse, GetPaymentSettingsError, GetPaymentSettingsResponse, ReturnType<typeof getPaymentSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPaymentSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPaymentSettingsQueryKey(options)
});

/**
 * Сохранить настройки залога
 */
export const saveDepositSettingsMutation = (options?: Partial<Options<SaveDepositSettingsData>>): UseMutationOptions<SaveDepositSettingsResponse, SaveDepositSettingsError, Options<SaveDepositSettingsData>> => {
    const mutationOptions: UseMutationOptions<SaveDepositSettingsResponse, SaveDepositSettingsError, Options<SaveDepositSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveDepositSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSourcesQueryKey = (options?: Options<ListSourcesData>) => createQueryKey('listSources', options);

/**
 * Список источников синхронизации броней
 */
export const listSourcesOptions = (options?: Options<ListSourcesData>) => queryOptions<ListSourcesResponse, ListSourcesError, ListSourcesResponse, ReturnType<typeof listSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSourcesQueryKey(options)
});

export const getSourceSyncScopeQueryKey = (options?: Options<GetSourceSyncScopeData>) => createQueryKey('getSourceSyncScope', options);

/**
 * Что именно синхронизируется с источниками
 *
 * Пояснительный список для экрана источников — не привязан к конкретному Source.
 */
export const getSourceSyncScopeOptions = (options?: Options<GetSourceSyncScopeData>) => queryOptions<GetSourceSyncScopeResponse, GetSourceSyncScopeError, GetSourceSyncScopeResponse, ReturnType<typeof getSourceSyncScopeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSourceSyncScope({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSourceSyncScopeQueryKey(options)
});

export const getConciergeQueryKey = (options?: Options<GetConciergeData>) => createQueryKey('getConcierge', options);

/**
 * Настройки AI-консьержа
 *
 * Возвращает пять серверных секций экрана: режим участия, характер, модель, лимиты и аналитику. Для собственной модели токен write-only: чтение возвращает только tokenState и lastCheck, а не сам токен.
 */
export const getConciergeOptions = (options?: Options<GetConciergeData>) => queryOptions<GetConciergeResponse, GetConciergeError, GetConciergeResponse, ReturnType<typeof getConciergeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConcierge({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConciergeQueryKey(options)
});

/**
 * Сохранить настройки AI-консьержа
 *
 * Сохраняет только клиентские настройки экрана: режим участия, редактируемые поля характера, выбор модели и лимиты. Серверные/read-only поля ответа не передаются обратно. Для provider = own фронт не должен сохранять настройки, пока live-check POST /concierge/model-check не вернул успех на текущую комбинацию endpoint/model/token/prices.
 */
export const saveConciergeMutation = (options?: Partial<Options<SaveConciergeData>>): UseMutationOptions<SaveConciergeResponse, SaveConciergeError, Options<SaveConciergeData>> => {
    const mutationOptions: UseMutationOptions<SaveConciergeResponse, SaveConciergeError, Options<SaveConciergeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveConcierge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Проверить собственную языковую модель
 *
 * Серверный live-check для provider = own. Фронт не проверяет токен, endpoint или модель самостоятельно: он только отправляет настройки и показывает серверный результат либо Problem.
 */
export const checkConciergeModelMutation = (options?: Partial<Options<CheckConciergeModelData>>): UseMutationOptions<CheckConciergeModelResponse, CheckConciergeModelError, Options<CheckConciergeModelData>> => {
    const mutationOptions: UseMutationOptions<CheckConciergeModelResponse, CheckConciergeModelError, Options<CheckConciergeModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkConciergeModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAuditEventsQueryKey = (options?: Options<ListAuditEventsData>) => createQueryKey('listAuditEvents', options);

/**
 * Журнал аудита
 */
export const listAuditEventsOptions = (options?: Options<ListAuditEventsData>) => queryOptions<ListAuditEventsResponse, ListAuditEventsError, ListAuditEventsResponse, ReturnType<typeof listAuditEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAuditEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditEventsQueryKey(options)
});

export const listAuditEventsInfiniteQueryKey = (options?: Options<ListAuditEventsData>): QueryKey<Options<ListAuditEventsData>> => createQueryKey('listAuditEvents', options, true);

/**
 * Журнал аудита
 */
export const listAuditEventsInfiniteOptions = (options?: Options<ListAuditEventsData>) => {
    const opts = infiniteQueryOptions<ListAuditEventsResponse, ListAuditEventsError, InfiniteData<ListAuditEventsResponse>, QueryKey<Options<ListAuditEventsData>>, Cursor | Pick<QueryKey<Options<ListAuditEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAuditEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAuditEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAuditEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listSecretRevealsQueryKey = (options?: Options<ListSecretRevealsData>) => createQueryKey('listSecretReveals', options);

/**
 * Журнал выдач кодов доступа
 *
 * Каждая запись — ВЫДАЧА кода гостю по брони: сценарий дошёл до шага, бронь выполнила условия, код ушёл наружу. ⚠️ Записей «менеджер посмотрел» здесь не бывает и быть не может — сервис секретов не отдаёт значения менеджеру вовсе (2.9), и операции раскрытия у нас поэтому нет. Отдельная ручка от listAuditEvents: выдачи требуют собственного списка с полями объекта, секрета и брони, которых нет в общем событии аудита.
 */
export const listSecretRevealsOptions = (options?: Options<ListSecretRevealsData>) => queryOptions<ListSecretRevealsResponse, ListSecretRevealsError, ListSecretRevealsResponse, ReturnType<typeof listSecretRevealsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSecretReveals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSecretRevealsQueryKey(options)
});

export const listSecretRevealsInfiniteQueryKey = (options?: Options<ListSecretRevealsData>): QueryKey<Options<ListSecretRevealsData>> => createQueryKey('listSecretReveals', options, true);

/**
 * Журнал выдач кодов доступа
 *
 * Каждая запись — ВЫДАЧА кода гостю по брони: сценарий дошёл до шага, бронь выполнила условия, код ушёл наружу. ⚠️ Записей «менеджер посмотрел» здесь не бывает и быть не может — сервис секретов не отдаёт значения менеджеру вовсе (2.9), и операции раскрытия у нас поэтому нет. Отдельная ручка от listAuditEvents: выдачи требуют собственного списка с полями объекта, секрета и брони, которых нет в общем событии аудита.
 */
export const listSecretRevealsInfiniteOptions = (options?: Options<ListSecretRevealsData>) => {
    const opts = infiniteQueryOptions<ListSecretRevealsResponse, ListSecretRevealsError, InfiniteData<ListSecretRevealsResponse>, QueryKey<Options<ListSecretRevealsData>>, Cursor | Pick<QueryKey<Options<ListSecretRevealsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSecretRevealsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSecretReveals({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSecretRevealsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getBookingFormReferenceQueryKey = (options?: Options<GetBookingFormReferenceData>) => createQueryKey('getBookingFormReference', options);

/**
 * Справочники для формы создания брони
 */
export const getBookingFormReferenceOptions = (options?: Options<GetBookingFormReferenceData>) => queryOptions<GetBookingFormReferenceResponse, GetBookingFormReferenceError, GetBookingFormReferenceResponse, ReturnType<typeof getBookingFormReferenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingFormReference({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingFormReferenceQueryKey(options)
});
